import { Alert, Autocomplete, Box, Button, Card, CardContent, CardMedia, Chip, CircularProgress, Divider, FormControl, IconButton, InputLabel, MenuItem, OutlinedInput, Paper, Select, SelectChangeEvent, Tab, Tabs, TextField, Toolbar, Tooltip, Typography } from "@mui/material";
import { Circle, FeatureGroup, MapContainer, Marker, Polygon, Polyline, Popup, TileLayer } from "react-leaflet";

import DrawerBottomList from "./components/DrawerBottomList";

import "./styles.css";
import "leaflet/dist/leaflet.css";

import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import {
    AbcOutlined,
    ArrowBackOutlined,
    AppShortcutOutlined,
    BatteryCharging20Outlined,
    CheckCircleRounded,
    CloseOutlined,
    DirectionsCarFilledOutlined,
    DoNotDisturbOnRounded,
    EdgesensorHighOutlined,
    EventOutlined,
    FmdGoodOutlined,
    GroupsOutlined,
    KeyOutlined,
    LocationCityOutlined,
    ManageHistoryOutlined,
    MapOutlined,
    MyLocationOutlined,
    NearMeOutlined,
    PersonOutlineOutlined,
    PlaceOutlined,
    ReduceCapacityOutlined,
    RemoveCircleOutlineOutlined,
    SatelliteAltOutlined,
    SaveOutlined,
    SearchOutlined,
    SendToMobileOutlined,
    SendTwoTone,
    SettingsOutlined,
    SevenMpOutlined,
    SpeedOutlined,
    SwitchAccessShortcutAddOutlined,
    TapAndPlayOutlined,
    TouchAppOutlined,
    WhatsApp,
} from "@mui/icons-material";

import L from "leaflet";

import { useCookies } from "react-cookie";
import { VehicleDriverChangeType, VehicleGridType, SelectedParametersType, GeofenceType, UserType, EventTipType, EventActionType, CommandType, VehicleGroupType, VehicleBrandType, VehicleModelType, VehicleTypesType, SelectedParametersSimpleType, MqttCommandDeliveryStatusType, SendCommandType, InterestPointType } from "../../../types/types";

import Rmodal from "../../../components/Rmodal";
import { vehicleGridDefault } from "../../../consts/consts";
import { formatVoltage, getApiErrorMessage, getFilteredMultipleList, getMqttCommandStatusCardStyle, getMqttCommandStatusInfo, isMqttCommandProtocol, setToastRefToOpen, formattedSpeed, getTimezone, findNearestPoints, buildInterestPointShareMessage, buildAllInterestPointsShareMessage, openWhatsAppShare } from "../../../functions/functions";
import dayjs from "dayjs";

import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { selectedCustomerToManagerMapAtom, userAtom } from "../../../atoms/atoms";
import GridTemplate from "../../../components/GridTemplate";
import { GridColDef } from "@mui/x-data-grid";
import { Toast } from "primereact/toast";

import { findAllCommandsByDeviceIdListResponse } from "../../../resources/Api/device/findAllCommandsByDeviceIdListResponse";
import deviceEventActionFindAllByDevice from "../../../resources/Api/device/deviceEventActionFindAllByDevice";
import updateDeviceEventActionByDevice from "../../../resources/Api/device/updateDeviceEventActionByDevice";
import findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse from "../../../resources/Api/group/findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse";
import findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdGridResponse from "../../../resources/Api/vehicle/findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdGridResponse";
import findVehicleLive from "../../../resources/Api/vehicle/findVehicleLive";
import findVehicleDriverChanges from "../../../resources/Api/vehicle/findVehicleDriverChanges";
import findAllGeofencesByCustomerIdAndDepartmentIdCrudResponse from "../../../resources/Api/geofence/findAllGeofencesByCustomerIdAndDepartmentIdCrudResponse";
import findAllInterestPointsByCustomerIdCrudResponse from "../../../resources/Api/interestPoint/findAllInterestPointsByCustomerIdCrudResponse";
import sendCommandById from "../../../resources/Api/device/sendCommandById";
import sendCommandByIdMqtt from "../../../resources/Api/device/sendCommandByIdMqtt";
import findMqttCommandStatusByIdResponse from "../../../resources/Api/device/findMqttCommandStatusByIdResponse";
import findAllVehicleBrandsListResponse from "../../../resources/Api/vehicle/findAllVehicleBrandsListResponse";
import findAllVehicleTypesListResponse from "../../../resources/Api/vehicle/findAllVehicleTypesListResponse";
import findAllVehicleModelByBrandListResponse from "../../../resources/Api/vehicle/findAllVehicleModelsByBrandsListResponse";
import findAllEventTypesListResponse from "../../../resources/Api/event/findAllEventTypesListResponse";
import saveEventAction from "../../../resources/Api/device/saveEventAction";

import { Gcircle } from "./components/GCircle";
import { Gpolygon } from "./components/GPolygon";
import { GPolyline } from "./components/GPolyline";
import { Gmarker, buildInterestPointInfoWindowContent } from "./components/Gmarker";
import GPositionsMarkers, { GPositionsMarkersHandle } from "./components/GPositionsMarkers";
import DriverChangeSummary from "./components/DriverChangeSummary";
import OpenPositionsMarkers, { OpenPositionsMarkersHandle } from "./components/OpenPositionMarker";
import MapSearch from "./components/MapSearch";
import TabPanel from "./components/TabPanel";
import GPositionsMap from "../../../components/example/GPositionMap";
import { isImpersonationLocked } from "../../../utils/impersonation";

const buildInterestPointIcon = (color?: string) =>
    L.divIcon({
        className: "interest-point-marker",
        html: `<div style="background:${color || "#003f4a"};width:22px;height:22px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,0.4);"></div>`,
        iconSize: [22, 22],
        iconAnchor: [11, 22],
        popupAnchor: [0, -22],
    });

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={<KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <DoNotDisturbOnRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "eventType",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Evento"}
                icon={
                    <EventOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.eventType ?? ""}
            />
        ),
    },
    {
        field: "comando",
        align: "left",
        width: 150,
        headerClassName: "last-column",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Comando"}
                icon={
                    <TouchAppOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.commandId}
            />
        ),
    },
    {
        field: "accessIcon",
        sortable: false,
        headerName: "",
        width: 150,
        renderCell: (item) => (
            <Chip
                className="chip-access"
                sx={{
                    marginRight: 2,
                    fontFamily: "Prometo",
                    background: item.row.activated ? "rgba(220, 53, 69, 1)" : "#00B700",
                    color: "#ffff",
                    padding: 1,
                }}
                onClick={() => {
                    item.row?.callback(!item.row.activated ? "activated" : "deactivated");
                }}
                label={!item.row.activated ? "Ativar" : "Desativar"}
                icon={
                    item.row.activated ? <RemoveCircleOutlineOutlined style={{ height: 30, width: 30, fill: "#ffff" }} /> : <SwitchAccessShortcutAddOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
    },
];

const rowsOptions = (
    list: Array<any>,
    callback?: (...args: any) => Promise<void>
): Array<any> => {
    const result = [...list];
    return result.map((item) => ({ ...item, callback }));
};

const mapFilterFieldSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: 56,
        borderRadius: 2,
        backgroundColor: "#ffffff",
        transition: "box-shadow 200ms ease, border-color 200ms ease",
        "& fieldset": { borderColor: "rgba(0, 63, 74, 0.24)" },
        "&:hover fieldset": { borderColor: "#006C77" },
        "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(0, 183, 0, 0.12)" },
        "&.Mui-focused fieldset": { borderColor: "#00B700" },
    },
    "& .MuiInputLabel-root": { fontFamily: "Prometo" },
};

const DashMap = ({ isHiddenMenu, isFixedMenu = false, isMenuOverlayOpen = false, showGeofences, showInterestPoints = false, showCarsFilter, showMapChanger, showMapSearch, actions }: { isHiddenMenu: boolean, isFixedMenu?: boolean, isMenuOverlayOpen?: boolean, showGeofences: boolean, showInterestPoints?: boolean, showCarsFilter: boolean, showMapChanger: boolean, showMapSearch: boolean, actions: Array<{ name: string, action: (value: boolean) => void }> }) => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    const selectedCustomerToManagerMap = useRecoilValue<SelectedParametersSimpleType>(
        selectedCustomerToManagerMapAtom
    );

    // functionalities states
    const [loading, setLoading] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<
        "warn" | "success" | "info" | "error" | undefined
    >("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    // states
    const [nearbyRoute, setNearbyRoute] = useState<{
        origin: VehicleGridType;
        nearest: VehicleGridType;
        distanceText: string;
        durationText: string;
    } | null>(null);

    const [isOpenCarsDetails, setIsOpenCarsDetails] = useState<boolean>(false);
    const [selectedVehicle, setSelectedVehicle] = useState<VehicleGridType>(vehicleGridDefault);
    const [selectedEventAction, setSelectedEventAction] = useState<EventActionType>({} as any);

    const [deviceCommandName, setDeviceCommandName] = useState<string>("");
    const [eventTypeName, setEventTypeName] = useState<string>("");

    const [deviceCommandsList, setDeviceCommandList] = useState<Array<CommandType>>([]);
    const [loadingCommands, setLoadingCommands] = useState<boolean>(false);
    const [mqttCommandDelivery, setMqttCommandDelivery] = useState<MqttCommandDeliveryStatusType | null>(null);
    const [eventTypesList, setEventTypesList] = useState<Array<EventTipType>>([]);
    const [geofencesList, setGeofenceList] = useState<Array<GeofenceType>>([]);
    const [interestPointsList, setInterestPointsList] = useState<Array<InterestPointType>>([]);
    const [geofencesMapList, setGeofenceMapList] = useState<Array<any>>([]);
    const [interestPointsMapList, setInterestPointsMapList] = useState<Array<any>>([]);
    const [interestPointsGoogleMapList, setInterestPointsGoogleMapList] = useState<Array<any>>([]);
    const [carsList, setCarsList] = useState<Array<VehicleGridType>>([]);
    const [filteredList, setFilteredList] = useState<Array<VehicleGridType>>([]);
    const [checkedVehicles, setCheckedVehicles] = useState<readonly any[]>([]);
    const [dismissNearbyPoints, setDismissNearbyPoints] = useState<boolean>(false);

    const [deviceActionList, setDeviceActionList] = useState<Array<EventActionType>>([]);
    const [groupsList, setGroupsList] = useState<Array<VehicleGroupType>>([]);
    const [vehicleBrandsList, setVehicleBrandsList] = useState<Array<VehicleBrandType>>([]);
    const [vehicleModelsList, setVehicleModelList] = useState<Array<VehicleModelType>>([]);
    const [vehicleTypesList, setVehicleTypesList] = useState<Array<VehicleTypesType>>([]);

    const [groupName, setGroupName] = useState<string>("");
    const [brandName, setBrandName] = useState<string>("");
    const [modelName, setModelName] = useState<string>("");
    const [typeName, setTypeName] = useState<string>("");
    const [name, setName] = useState<string>("");

    const [value, setValue] = useState(0);
    const [showDriverDetails, setShowDriverDetails] = useState(false);
    const [showCarFilter, setShowCarFilter] = useState<boolean>(false);
    const [showChanger, setShowMapChanger] = useState<boolean>(false);
    const [showSearch, setShowMapSearch] = useState<boolean>(false);
    const [selectedMap, setSelectedMap] = useState<string>("leaflet");
    const [liveVehicleId, setLiveVehicleId] = useState<number | null>(null);
    const [driverChangesByVehicle, setDriverChangesByVehicle] = useState<Record<number, VehicleDriverChangeType[]>>({});
    const [driverHistoryErrors, setDriverHistoryErrors] = useState<Record<number, boolean>>({});
    const [driverHistoryLoading, setDriverHistoryLoading] = useState<Record<number, boolean>>({});
    const isLiveMode = liveVehicleId !== null;
    const [refreshVersion, setRefreshVersion] = useState(0);

    // refs
    const filteredIdsRef = useRef<any>([]);
    const toastModalRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);
    const mapRef = useRef<any>(null);
    const vehicleDetailsContentRef = useRef<HTMLDivElement>(null);
    const mqttPollingTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const mqttCommandIdRef = useRef<string | null>(null);
    const commandsRequestVersionRef = useRef<number>(0);
    const liveVehicleIdRef = useRef(liveVehicleId);
    liveVehicleIdRef.current = liveVehicleId;
    const gPositionsMarkersRef = useRef<GPositionsMarkersHandle>(null);
    // Cada clique numa linha da grade volta a seguir o veículo aberto, mesmo que o mapa tenha sido arrastado
    const [followRequest, setFollowRequest] = useState<number>(0);
    const openPositionsMarkersRef = useRef<OpenPositionsMarkersHandle>(null);

    const stopMqttCommandPolling = useCallback(() => {
        mqttCommandIdRef.current = null;
        if (mqttPollingTimeoutRef.current) {
            clearTimeout(mqttPollingTimeoutRef.current);
            mqttPollingTimeoutRef.current = null;
        }
    }, []);

    const mqttCommandStatusInfo = useMemo(
        () => getMqttCommandStatusInfo(mqttCommandDelivery?.status),
        [mqttCommandDelivery?.status]
    );
    const selectedCommandProtocol = useMemo(
        () => deviceCommandsList.find((item) => item.description === deviceCommandName)?.protocolName
            ?? deviceCommandsList.find((item) => item.protocolName)?.protocolName
            ?? selectedVehicle.position?.protocol,
        [deviceCommandName, deviceCommandsList, selectedVehicle.position?.protocol]
    );

    // cookies
    const [cookies] = useCookies([
        "selectedParameters",
        "selectedMap",
        "token",
    ]);

    const modalVehicleId = isOpenCarsDetails && showDriverDetails ? selectedVehicle.id : null;
    const historyToken = cookies.token || sessionStorage.getItem("token");
    const historyCustomerId = getCurrentUser.configs.isManager
        ? selectedCustomerToManagerMap.customerId : cookies.selectedParameters?.customer?.id;
    const historyDepartmentId = getCurrentUser.configs.isManager
        ? selectedCustomerToManagerMap.departmentId : cookies.selectedParameters?.department?.id;
    const historyIgnoreDepartments = getCurrentUser.configs.isManager
        ? selectedCustomerToManagerMap.isViewingAll : cookies.selectedParameters?.isViewingAll;

    useEffect(() => {
        const vehicleIds = [...new Set([liveVehicleId, modalVehicleId].filter((id): id is number =>
            typeof id === "number" && id > 0
        ))];
        setDriverChangesByVehicle({});
        setDriverHistoryErrors({});
        if (!vehicleIds.length || !historyToken || !historyCustomerId || historyDepartmentId == null) {
            setDriverHistoryLoading({});
            return;
        }
        setDriverHistoryLoading(Object.fromEntries(vehicleIds.map(id => [id, true])));
        const request = new AbortController();

        vehicleIds.forEach(vehicleId => {
            void findVehicleDriverChanges(
                historyToken, vehicleId, historyCustomerId, historyDepartmentId,
                Boolean(historyIgnoreDepartments), request.signal
            ).then(({ data }) => {
                if (request.signal.aborted) return;
                setDriverChangesByVehicle(previous => ({ ...previous, [vehicleId]: data }));
                setDriverHistoryErrors(previous => ({ ...previous, [vehicleId]: false }));
                setDriverHistoryLoading(previous => ({ ...previous, [vehicleId]: false }));
            }).catch(() => {
                if (!request.signal.aborted) {
                    setDriverHistoryErrors(previous => ({ ...previous, [vehicleId]: true }));
                    setDriverHistoryLoading(previous => ({ ...previous, [vehicleId]: false }));
                }
            });
        });

        return () => request.abort();
    }, [liveVehicleId, modalVehicleId, historyToken, historyCustomerId,
        historyDepartmentId, historyIgnoreDepartments]);

    // hooks
    const location = useLocation();
    const canViewCommands = Boolean(location?.state?.commands?.canView);
    const canSendCommands = canViewCommands && Boolean(location?.state?.commands?.canCreate);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setShowDriverDetails(false);
        setValue(newValue);
    };

    useEffect(() => {
        if (vehicleDetailsContentRef.current) vehicleDetailsContentRef.current.scrollTop = 0;
    }, [showDriverDetails, value, selectedVehicle.id]);

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setDeviceCommandName("");
        setEventTypeName("");
    }, []);

    useEffect(() => {
        const ref = isOpenCarsDetails ? toastModalRef : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenCarsDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    useEffect(() => {
        if (showCarsFilter) {
            if (!showCarFilter) {
                setShowCarFilter(true);
                actions.find((a) => a.name === "showMapChanger")?.action(false);
                actions.find((a) => a.name === "showMapSearch")?.action(false);
            }
        } else {
            setShowCarFilter(false);
            setBrandName("");
            setName("");
            setTypeName("");
            setModelName("");
            setGroupName("");
        }

        if (showMapChanger && isLiveMode) {
            setShowMapChanger(false);
            actions.find(a => a.name === "showMapChanger")?.action(false);
            setTextValidation("Encerre o acompanhamento ao vivo antes de trocar o mapa.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
        } else if (showMapChanger) {
            if (!showChanger) {
                setShowMapChanger(true);
                actions.find((a) => a.name === "showCarsFilter")?.action(false);
                actions.find((a) => a.name === "showMapSearch")?.action(false);
            }
        } else {
            setShowMapChanger(false);
        }

        if (showMapSearch) {
            if (!showSearch) {
                setShowMapSearch(true);
                actions.find((a) => a.name === "showCarsFilter")?.action(false);
                actions.find((a) => a.name === "showMapChanger")?.action(false);
            }
        } else {
            setShowMapSearch(false);
        }
    }, [showCarsFilter, showMapChanger, showMapSearch, actions, showChanger, showSearch, showCarFilter, isLiveMode]);

    const getFilterFieldsData = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        if (groupsList.length === 0) {
            try {
                const [groups, brands, types] = await Promise.all([
                    findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse(token, getCurrentUser.customer.id, getCurrentUser.id, currentParameters.department.id, "activated", currentParameters?.isViewingAll),
                    findAllVehicleBrandsListResponse(token),
                    findAllVehicleTypesListResponse(token)
                ]);
                setGroupsList(groups.data);
                setVehicleBrandsList(brands.data);
                setVehicleTypesList(types.data);
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
            }
        }
    }, [groupsList.length, cookies.token, cookies.selectedParameters, getCurrentUser.customer.id, getCurrentUser.id]);

    const getVehicleModelsList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const brandId = vehicleBrandsList.find((item) => item.name === brandName)?.id;
        if (!brandId) return;
        try {
            const { data } = await findAllVehicleModelByBrandListResponse(token, brandId);
            setVehicleModelList(data);
        } catch (error: any) {
            console.log(error);
            setVehicleModelList([]);
        }
    }, [cookies.token, vehicleBrandsList, brandName]);

    useEffect(() => {
        if (brandName) {
            getVehicleModelsList();
        }
    }, [getVehicleModelsList, brandName]);

    useEffect(() => {
        getFilterFieldsData();
    }, [getFilterFieldsData]);

    const getAllEventActionsByDevice = useCallback(async (activated: string = "activated", page: number = 0, size: number = 100) => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        if (!selectedVehicle?.deviceId) return;
        try {
            const { data } = await deviceEventActionFindAllByDevice(token, selectedVehicle.deviceId, page, size);

            setDeviceActionList(data.content);
            setIsLastPage(data.last);
            setNumberOfElementsPerPage(data.numberOfElements);
            setPageNumber(data.pageable.pageNumber);

            if (data.first) {
                setNumberOfElements(data.totalElements);
            }
        } catch (error: any) {
            console.log(error);
            setDeviceActionList([]);
        }
    }, [cookies.token, selectedVehicle?.deviceId]);

    const getAllVehicles = useCallback(async (signal?: AbortSignal) => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        const userId = getCurrentUser.configs.isManager ? -1 : getCurrentUser.id;
        const customerId = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.customerId : currentParameters.customer.id;
        const departmentId = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.departmentId : currentParameters.department.id;
        const viewAll = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.isViewingAll : currentParameters?.isViewingAll;

        setLoading(true);
        try {
            const { data } =
                await findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdGridResponse(
                    token,
                    userId,
                    customerId,
                    departmentId,
                    viewAll,
                    signal
                );
            if (!signal?.aborted) setCarsList(data);
        } finally {
            if (!signal?.aborted) setLoading(false);
        }
    }, [cookies.selectedParameters, getCurrentUser.id, cookies.token, getCurrentUser.configs.isManager, selectedCustomerToManagerMap]);

    useEffect(() => {
        // Mantém os intervalos existentes e impede requisições simultâneas.
        const intervalTime = isLiveMode ? 10000 : 40000;
        let disposed = false;
        let controller: AbortController | null = null;
        let lastError = "";

        const fetchCurrentData = async () => {
            if (disposed || controller || document.hidden) return;
            const request = new AbortController();
            controller = request;
            try {
                if (liveVehicleId !== null) {
                    // Pega os parâmetros no momento da requisição (evita problemas de dependências no useEffect)
                    const token = cookies.token || sessionStorage.getItem("token");
                    const currentParams = cookies.selectedParameters;
                    const customerId = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.customerId : currentParams.customer.id;
                    const departmentId = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.departmentId : currentParams.department.id;
                    const viewAll = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.isViewingAll : currentParams?.isViewingAll;

                    // Busca a posição do veículo específico
                    const { data } = await findVehicleLive(token, liveVehicleId, customerId, departmentId, viewAll, request.signal);
                    if (disposed || request.signal.aborted) return;

                    if (data && data.id === liveVehicleId) {
                        const position = data.position;

                        setCarsList(previous => previous.map(vehicle =>
                            vehicle.id === liveVehicleId
                                ? { ...vehicle, ...data, position: position ?? vehicle.position }
                                : vehicle
                        ));
                    }
                } else {
                    // Modo Normal: busca todos os veículos
                    await getAllVehicles(request.signal);
                }
                lastError = "";
            } catch (error) {
                if (disposed || request.signal.aborted) return;
                const message = getApiErrorMessage(error, "Não foi possível atualizar os veículos. Tente novamente.");
                if (message !== lastError) {
                    lastError = message;
                    setTextValidation(message);
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                }
            } finally {
                controller = null;
            }
        };

        void fetchCurrentData();
        const intervalId = setInterval(fetchCurrentData, intervalTime);
        const onVisibilityChange = () => { if (!document.hidden) void fetchCurrentData(); };
        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => {
            disposed = true;
            clearInterval(intervalId);
            controller?.abort();
            document.removeEventListener("visibilitychange", onVisibilityChange);
            setLoading(false);
        };
    }, [getAllVehicles, cookies.selectedParameters, cookies.token, getCurrentUser.configs.isManager, isLiveMode, selectedCustomerToManagerMap.customerId, selectedCustomerToManagerMap.departmentId, selectedCustomerToManagerMap.isViewingAll, liveVehicleId, refreshVersion]);

    useEffect(() => {
        setLiveVehicleId(null);
    }, [cookies.selectedParameters, selectedCustomerToManagerMap]);

    useEffect(() => {
        const mapCookie: string = localStorage.getItem("selectedMap") ?? "";
        if (mapCookie && !isLiveMode) {
            setSelectedMap(mapCookie);
        }
    }, [cookies.selectedMap, isLiveMode]);

    const onChangeMap = useCallback((map: string) => {
        if (liveVehicleIdRef.current !== null) {
            setTextValidation("Encerre o acompanhamento ao vivo antes de trocar o mapa.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            return;
        }
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            if (liveVehicleIdRef.current !== null) return;
            setSelectedMap(map);
            localStorage.setItem("selectedMap", map);
            actions.find((a) => a.name === "showMapChanger")?.action(false);
        }, 2000);
    }, [actions]);

    const onSaveAutomaticEventAction = useCallback(
        async () => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const matchedCommand = deviceCommandsList.find((item) => item.type === deviceCommandName);
            if (!selectedVehicle?.deviceId || !matchedCommand) return;

            try {
                await saveEventAction(
                    token,
                    selectedVehicle.deviceId,
                    {
                        id: -1,
                        eventType: eventTypeName,
                        sendAlways: true,
                        attributes: "{}",
                        commandId: matchedCommand.id,
                        notificator: "command"
                    }
                );
                setTextValidation("Comando automático definido com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response;
                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                }, 3000);
            }
        },
        [cookies.token, eventTypeName, deviceCommandsList, deviceCommandName, selectedVehicle?.deviceId, handleClose]
    );

    const trackMqttCommand = useCallback((commandId: string, token: string, expiresAt?: string | null) => {
        stopMqttCommandPolling();
        mqttCommandIdRef.current = commandId;

        let consecutiveErrors = 0;
        const expiresAtMillis = expiresAt ? Date.parse(expiresAt) : Number.NaN;

        const poll = async () => {
            if (mqttCommandIdRef.current !== commandId) return;

            try {
                const { data } = await findMqttCommandStatusByIdResponse(token, commandId);
                if (mqttCommandIdRef.current !== commandId) return;

                consecutiveErrors = 0;
                setMqttCommandDelivery(data);

                const statusInfo = getMqttCommandStatusInfo(data.status);
                if (statusInfo.terminal) {
                    stopMqttCommandPolling();
                    const detail = data.response?.trim() || data.error?.trim();
                    setTextValidation(detail ? `${statusInfo.label}: ${detail}` : statusInfo.label);
                    setStatusMessage(statusInfo.severity);
                    setFieldsIsValid(false);
                    return;
                }
            } catch (error: any) {
                if (mqttCommandIdRef.current !== commandId) return;

                consecutiveErrors += 1;
                const status = error?.response?.status;
                const mustStop = status === 401 || status === 403 || status === 404 || consecutiveErrors >= 3;

                if (mustStop) {
                    stopMqttCommandPolling();
                    setTextValidation(
                        getApiErrorMessage(error, "Não foi possível acompanhar o retorno do comando.")
                    );
                    setStatusMessage(status === 401 || status === 403 ? "error" : "warn");
                    setFieldsIsValid(false);
                    return;
                }
            }

            if (!Number.isNaN(expiresAtMillis) && Date.now() > expiresAtMillis + 15000) {
                stopMqttCommandPolling();
                setTextValidation("O prazo do comando terminou sem confirmação do status final.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
                return;
            }

            mqttPollingTimeoutRef.current = setTimeout(poll, 2000);
        };

        void poll();
    }, [stopMqttCommandPolling]);

    useEffect(() => () => stopMqttCommandPolling(), [stopMqttCommandPolling]);

    useEffect(() => {
        stopMqttCommandPolling();
        setMqttCommandDelivery(null);
        setDeviceCommandList([]);
        setDeviceCommandName("");
    }, [selectedVehicle.deviceId, stopMqttCommandPolling]);

    useEffect(() => {
        if (!isOpenCarsDetails) {
            stopMqttCommandPolling();
            setMqttCommandDelivery(null);
        }
    }, [isOpenCarsDetails, stopMqttCommandPolling]);

    const onSendCommand = useCallback(
        async () => {
            if (loading || loadingCommands) return;
            if (!canSendCommands || isImpersonationLocked()) {
                setTextValidation("Você não possui permissão para enviar comandos.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
                return;
            }

            const token: string = cookies.token || sessionStorage.getItem("token");
            const currentParameters: SelectedParametersType = cookies.selectedParameters;
            const customerId = getCurrentUser.configs.isManager
                ? selectedCustomerToManagerMap.customerId
                : currentParameters?.customer?.id;
            const selectedCommand = deviceCommandsList.find((item) => item.description === deviceCommandName);
            if (!customerId || customerId < 1 || !selectedVehicle.deviceId || selectedVehicle.deviceId < 1 || !selectedCommand) {
                setTextValidation("Selecione um cliente, um veículo e um comando válido para enviar.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
                return;
            }

            setLoading(true);
            const isMqttCommand = isMqttCommandProtocol(selectedCommandProtocol);

            const dataCommand: SendCommandType = {
                token: token,
                deviceType: "PRINCIPAL",
                commandDesc: deviceCommandName,
                deviceId: selectedVehicle?.deviceId as number,
                deviceImei: isMqttCommand
                    ? selectedVehicle.deviceImei ?? ""
                    : `${selectedVehicle.name} - ${selectedVehicle.vehiclePlate}(${selectedVehicle.deviceImei})`,
                customerId: customerId,
                name: getCurrentUser.name,
                email: getCurrentUser.email,
                isCommandLine: false,
                cameraConfig: null
            };

            try {
                const response = isMqttCommand
                    ? await sendCommandByIdMqtt(dataCommand)
                    : await sendCommandById(dataCommand);

                if (isMqttCommand) {
                    const commandId = response.data.commandId;
                    if (!commandId) {
                        setTextValidation("O comando foi recebido, mas não retornou um identificador para acompanhamento.");
                        setStatusMessage("warn");
                        setFieldsIsValid(false);
                        return;
                    }

                    setMqttCommandDelivery({
                        commandId,
                        deviceId: response.data.deviceId,
                        imei: response.data.imei ?? "",
                        status: "PENDING_PUBLISH",
                        description: dataCommand.commandDesc,
                        expiresAt: "",
                        publishedAt: null,
                        sentToDeviceAt: null,
                        respondedAt: null,
                        response: null,
                        error: null,
                    });
                    trackMqttCommand(commandId, token, response.data.expiresAt);
                    setTextValidation("Comando adicionado à fila para envio.");
                } else {
                    setTextValidation("Comando enviado com sucesso.");
                }

                setStatusMessage(isMqttCommand ? "info" : "success");
                setFieldsIsValid(false);
            } catch (error: any) {
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(getApiErrorMessage(error, "Erro ao enviar comando. Tente novamente."));
            } finally {
                setLoading(false);
                if (isMqttCommand) {
                    setDeviceCommandName("");
                } else {
                    setTimeout(() => {
                        handleClose();
                    }, 3000);
                }
            }
        },
        [handleClose, cookies.token, deviceCommandName, deviceCommandsList, selectedVehicle.deviceId, selectedCommandProtocol, cookies.selectedParameters, getCurrentUser.email, getCurrentUser.name, getCurrentUser.configs.isManager, selectedCustomerToManagerMap.customerId, selectedVehicle.deviceImei, selectedVehicle.name, selectedVehicle.vehiclePlate, trackMqttCommand, canSendCommands, loading, loadingCommands]
    );

    const onUpdateStatus = useCallback(
        async (status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            if (!selectedVehicle?.deviceId) return;

            setLoading(true);
            try {
                await updateDeviceEventActionByDevice(
                    token,
                    selectedVehicle.deviceId,
                    selectedEventAction.id,
                    status
                );
                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    getAllEventActionsByDevice();
                }, 8000);
            }
        },
        [cookies.token, getAllEventActionsByDevice, handleClose, selectedEventAction.id, selectedVehicle?.deviceId]
    );

    const getAllEventTypesList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await findAllEventTypesListResponse(token);
            if (data.length > 0) {
                setEventTypesList(data);
            }
        } catch (error: any) {
            console.log(error);
            setEventTypesList([]);
        }
    }, [cookies.token]);

    const getAllCommandsByDevice = useCallback(async () => {
        const requestVersion = ++commandsRequestVersionRef.current;
        setDeviceCommandList([]);
        setDeviceCommandName("");
        setLoadingCommands(false);
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;
        const managerId = getCurrentUser.configs.isManager
            ? currentParameters?.customer?.id
            : getCurrentUser.customer.managerId;
        if (!canViewCommands || !selectedVehicle.deviceImei || !selectedVehicle.deviceId || selectedVehicle.deviceId < 1) {
            return;
        }
        if (!managerId || managerId < 1) {
            setTextValidation("Não foi possível identificar a administradora para buscar os comandos. Selecione os parâmetros novamente.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            return;
        }

        setLoadingCommands(true);
        try {
            const { data } = await findAllCommandsByDeviceIdListResponse(
                token,
                managerId,
                selectedVehicle.deviceId,
                "PRINCIPAL"
            );
            if (requestVersion !== commandsRequestVersionRef.current) return;
            setDeviceCommandList(data);
        } catch (error: unknown) {
            if (requestVersion !== commandsRequestVersionRef.current) return;
            setDeviceCommandList([]);
            setTextValidation(getApiErrorMessage(error, "Erro ao buscar os comandos do dispositivo."));
            setStatusMessage("warn");
            setFieldsIsValid(false);
        } finally {
            if (requestVersion === commandsRequestVersionRef.current) {
                setLoadingCommands(false);
            }
        }
    }, [cookies.token, selectedVehicle.deviceId, selectedVehicle.deviceImei, cookies.selectedParameters, getCurrentUser.configs.isManager, getCurrentUser.customer.managerId, canViewCommands]);

    useEffect(() => {
        if (!isOpenCarsDetails) return;
        getAllCommandsByDevice();
        return () => {
            commandsRequestVersionRef.current += 1;
        };
    }, [getAllCommandsByDevice, isOpenCarsDetails]);

    useEffect(() => {
        if (isOpenCarsDetails && selectedVehicle.deviceImei) {
            getAllEventTypesList();
            getAllEventActionsByDevice();
        }
    }, [getAllEventTypesList, getAllEventActionsByDevice, selectedVehicle.deviceImei, isOpenCarsDetails]);

    const getAllGeofences = useCallback(async (status: string = "activated", page: number = 0, size: number = 20) => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;
        try {
            const { data } =
                await findAllGeofencesByCustomerIdAndDepartmentIdCrudResponse(
                    token,
                    getCurrentUser.id,
                    currentParameters.customer.id,
                    currentParameters.department.id,
                    status,
                    page,
                    size,
                    currentParameters.isViewingAll
                );
            if (data.content.length > 0) {
                setGeofenceList(data.content);
            }
        } catch (error: any) {
            console.log(error);
            setGeofenceList([]);
        }
    }, [cookies.selectedParameters, cookies.token, getCurrentUser.id]);

    const getAllInterestPoints = useCallback(async (status: string = "activated", page: number = 0, size: number = 20) => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;
        try {
            const { data } = await findAllInterestPointsByCustomerIdCrudResponse(
                token,
                getCurrentUser.id,
                currentParameters.customer.id,
                status,
                page,
                size,
            );
            if (data.content?.length > 0) {
                setInterestPointsList(data.content);
            } else {
                setInterestPointsList([]);
            }
        } catch (error: any) {
            console.log(error);
            setInterestPointsList([]);
        }
    }, [cookies.selectedParameters, cookies.token, getCurrentUser.id]);

    useEffect(() => {
        if (showGeofences && geofencesList.length === 0) {
            getAllGeofences();
        }
    }, [getAllGeofences, showGeofences, geofencesList.length]);

    useEffect(() => {
        if (showInterestPoints && interestPointsList.length === 0) {
            getAllInterestPoints();
        }
    }, [getAllInterestPoints, showInterestPoints, interestPointsList.length]);

    const renderGeofences = useCallback(() => {
        const list = geofencesList.map((item) => {
            const area = JSON.parse(item.area) ?? null;
            if (area) {
                const coords = area?.coordinates;
                const type = area?.type;
                const radius = area?.radius ?? 0;

                if (type === "circle") {
                    return (
                        <Circle key={item.id} center={coords} radius={radius} color={item?.groupColor} />
                    );
                } else if (type === "polygon") {
                    return <Polygon key={item.id} positions={coords} color={item?.groupColor} />;
                } else if (type === "polyline") {
                    return <Polyline key={item.id} positions={coords} color={item?.groupColor} />;
                }
            }
            return null;
        });
        setGeofenceMapList(list.filter(Boolean));
    }, [geofencesList]);

    const renderInterestPointsMarkers = useCallback(() => {
        const list = interestPointsList.map((item) => (
            <Marker
                key={`interest-${item.id}`}
                position={[item.latitude, item.longitude]}
                icon={buildInterestPointIcon(item.color)}
            >
                <Popup>
                    <Box sx={{ minWidth: 180, fontFamily: "Prometo" }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                            {item.name}
                        </Typography>
                        {item.description && (
                            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                {item.description}
                            </Typography>
                        )}
                        {item.address && (
                            <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                                {item.address}
                            </Typography>
                        )}
                        <Box
                            onClick={() => openWhatsAppShare(buildInterestPointShareMessage(item))}
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                mt: 0.5,
                                cursor: "pointer",
                                color: "#25D366",
                            }}
                        >
                            <WhatsApp fontSize="small" />
                            <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                                Compartilhar
                            </Typography>
                        </Box>
                    </Box>
                </Popup>
            </Marker>
        ));
        setInterestPointsMapList(list);
    }, [interestPointsList]);

    const renderGoogleMapsGeofences = useCallback(() => {
        const list = geofencesList.map((item) => {
            const area = JSON.parse(item.area) ?? null;
            if (area) {
                const coords = area?.coordinates;
                const type = area?.type;
                const radius = area?.radius ?? 0;

                if (type === "circle") {
                    return <Gcircle key={item.id} center={coords} radius={radius} fillColor={item.groupColor} strokeColor={item.groupColor} />;
                } else if (type === "polygon") {
                    return <Gpolygon key={item.id} paths={coords} fillColor={item.groupColor} strokeColor={item.groupColor} />;
                } else if (type === "polyline") {
                    return <GPolyline key={item.id} path={coords} strokeColor={item.groupColor} />;
                }
            }
            return null;
        });

        setGeofenceMapList(list.filter(Boolean));
    }, [geofencesList]);

    const renderGoogleMapsInterestPoints = useCallback(() => {
        const list = interestPointsList.map((item) => (
            <Gmarker
                key={`interest-gmap-${item.id}`}
                position={{ lat: item.latitude, lng: item.longitude }}
                pinColor={item.color}
                title={item.name}
                infoWindowContent={buildInterestPointInfoWindowContent({
                    ...item,
                    whatsappShareUrl: `https://wa.me/?text=${encodeURIComponent(buildInterestPointShareMessage(item))}`,
                })}
            />
        ));
        setInterestPointsGoogleMapList(list);
    }, [interestPointsList]);

    useEffect(() => {
        if (showGeofences) {
            if (selectedMap === "gmaps") {
                renderGoogleMapsGeofences();
            } else {
                renderGeofences();
            }
        } else {
            setGeofenceMapList([]);
        }
    }, [renderGoogleMapsGeofences, showGeofences, renderGeofences, selectedMap]);

    useEffect(() => {
        if (showInterestPoints) {
            if (selectedMap === "gmaps") {
                renderGoogleMapsInterestPoints();
            } else {
                renderInterestPointsMarkers();
            }
        } else {
            setInterestPointsMapList([]);
            setInterestPointsGoogleMapList([]);
        }
    }, [showInterestPoints, selectedMap, renderGoogleMapsInterestPoints, renderInterestPointsMarkers]);

    const MapChangerModal = useMemo(() => {
        return (
            <>
                <Toast
                    ref={toastRef}
                    style={{ zIndex: 999999 }}
                    position="top-center"
                    onShow={() => {
                        setIsToastVisible(true);
                        if (validationText) {
                            setTimeout(() => {
                                setFieldsIsValid(true);
                                setIsToastVisible(false);
                            }, 3000);
                        }
                    }}
                />
                <Rmodal
                    open={showChanger}
                    hiddenBackdrop
                    style={{ transition: "all 0.8s ease-out allow-discrete" }}
                >
                    <Paper
                        role="dialog"
                        aria-labelledby="map-selection-title"
                        className="map-selection-modal tw-overflow-hidden tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-shadow-2xl"
                        sx={{
                            ...style,
                            position: "relative",
                            padding: 0,
                            overflow: "hidden",
                            border: "1px solid rgba(0, 63, 74, 0.16)",
                            borderRadius: 4,
                            backgroundColor: "#ffff",
                            color: "text.primary",
                            boxShadow: "0 24px 70px rgba(0, 0, 0, 0.28)",
                        }}
                    >
                        <Box
                            className="map-selection-content row"
                            style={{ background: "#ffff", boxShadow: "none", padding: 0, margin: 0, display: "block" }}
                        >
                            <Box
                                className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-bg-gtr-sidebar tw-px-5 tw-py-4 tw-text-white"
                                sx={{
                                    paddingX: { xs: 2, sm: 3 },
                                    paddingY: 2,
                                    backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                                    borderTopLeftRadius: "inherit",
                                    borderTopRightRadius: "inherit",
                                }}
                            >
                                <Box className="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
                                    <Box
                                        className="tw-flex tw-h-14 tw-w-14 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-bg-white/10"
                                        sx={{ width: 56, height: 56, flexShrink: 0, borderRadius: 3, backgroundColor: "rgba(255,255,255,0.10)" }}
                                    >
                                        <MapOutlined sx={{ fontSize: 30 }} />
                                    </Box>
                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography id="map-selection-title" sx={{ color: "inherit", fontFamily: "Prometo", fontSize: { xs: 18, sm: 21 }, fontWeight: 700 }}>
                                            Seleção de mapa
                                        </Typography>
                                    </Box>
                                </Box>
                                <Tooltip title="Fechar" arrow placement="left">
                                    <IconButton
                                        aria-label="Fechar seleção de mapa"
                                        size="small"
                                        onClick={() => {
                                            onChangeMap(selectedMap);
                                            actions.find((a) => a.name === "showMapChanger")?.action(false);
                                        }}
                                        className="!tw-bg-white/10 !tw-text-white tw-transition-all tw-duration-200 hover:!tw-bg-red-500/70"
                                    >
                                        <CloseOutlined fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>

                            <Box
                                className="col-sm-12"
                                style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 10 }}
                            >
                                <Box onClick={() => onChangeMap("leaflet")} sx={{ background: "transparent", "& .leaflet-card:hover": { backgroundColor: "#00800036" } }}>
                                    <Card className="map-option-card leaflet-card" style={{ maxWidth: 350, margin: 10, padding: 20, marginRight: 8, cursor: "pointer" }} elevation={0}>
                                        <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <CardMedia
                                                style={{ height: 115, width: 250, objectFit: "contain" }}
                                                image={require("../../../assets/files/openmap.png")}
                                                role="img"
                                                aria-label="Prévia do Open Street Map"
                                            />
                                        </Box>
                                        <CardContent>
                                            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Typography variant="body2" component="div">
                                                    Open Street Map
                                                </Typography>
                                            </Box>
                                            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                    Use um mapa gratuito, disponível em todo o mundo que foi construído por voluntários, e lançado com uma licença de conteúdo aberto.
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>

                                <Box onClick={() => onChangeMap("gmaps")} sx={{ background: "transparent", "& .gmaps-card:hover": { backgroundColor: "#00800036" } }}>
                                    <Card className="map-option-card gmaps-card" style={{ maxWidth: 350, margin: 10, padding: 20, marginRight: 8, cursor: "pointer" }} elevation={0}>
                                        <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <CardMedia
                                                style={{ height: 115, width: 250, objectFit: "contain" }}
                                                image={require("../../../assets/files/googlemaps.png")}
                                                role="img"
                                                aria-label="Prévia do Google Maps"
                                            />
                                        </Box>
                                        <CardContent>
                                            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Typography variant="body2" component="div">
                                                    Google Maps
                                                </Typography>
                                            </Box>
                                            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                    Use um serviço de mapa web poderoso que fornece informações detalhadas sobre regiões geográficas e locais em todo o mundo.
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </Box>
                        </Box>
                    </Paper>
                </Rmodal>
            </>
        );
    }, [
        onChangeMap,
        validationText,
        showChanger,
        actions,
        selectedMap
    ]);

    const positionsList = useMemo(() => {
        return carsList
            .filter((car) => car?.position?.lat !== undefined)
            .map((car) => {
                return {
                    ...car,
                    isWhatsApp: (car.driver?.whatsApp || car.driver?.isWhatsApp),
                    attributes: JSON.parse(String(car?.position?.attributes || '{}'))
                };
            });
    }, [carsList]);

    const filter = useCallback((query: Array<string>) => {
        setLoading(true);
        if (query.some(a => a.length > 0)) {
            setLoading(true);
            const newList = getFilteredMultipleList(["groups", "vehicleBrandName", "vehicleModelName", "vehicleTypeName", "name", "vehiclePlate"], positionsList, query);
            if (newList.length === 0) {
                setTimeout(() => {
                    setLoading(false);
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation("Nenhum veículo encontrado com os dados fornecidos");
                }, 2000);
            } else {
                setFilteredList(newList);
                setTimeout(() => {
                    setLoading(false);
                    actions.find((a) => a.name === "showCarsFilter")?.action(false);
                }, 2000);
            }
        } else {
            setTimeout(() => {
                setLoading(false);
                setFilteredList(positionsList);
                actions.find((a) => a.name === "showCarsFilter")?.action(false);
            }, 2000);
        }
    }, [positionsList, actions]);

    useEffect(() => {
        filteredIdsRef.current = filteredList.map((item) => item.id);
    }, [filteredList]);

    useEffect(() => {
        if (filteredIdsRef.current.length > 0 && positionsList.length > 0) {
            const updatedFilteredList = positionsList.filter((item) =>
                filteredIdsRef.current.includes(item.id)
            );
            setFilteredList(updatedFilteredList);
        } else {
            setFilteredList(positionsList);
        }
    }, [positionsList]);

    const FiltersModal = useMemo(() => {
        return (
            <>
                <Toast
                    ref={toastRef}
                    style={{ zIndex: 999999 }}
                    position="top-center"
                    onShow={() => {
                        setIsToastVisible(true);
                        if (validationText) {
                            setTimeout(() => {
                                setFieldsIsValid(true);
                                setIsToastVisible(false);
                            }, 3000);
                        }
                    }}
                />
                <Rmodal
                    open={showCarFilter}
                    hiddenBackdrop
                    style={{ transition: "all 0.8s ease-out allow-discrete" }}
                >
                    <Paper
                        role="dialog"
                        aria-labelledby="vehicle-map-filter-title"
                        className="vehicle-map-filter-modal tw-flex tw-max-h-[calc(100dvh-24px)] tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-shadow-2xl"
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 999999,
                            display: "flex",
                            flexDirection: "column",
                            width: { xs: "calc(100vw - 24px)", sm: "min(86vw, 680px)" },
                            maxWidth: 680,
                            maxHeight: "calc(100dvh - 24px)",
                            padding: 0,
                            overflow: "hidden",
                            border: "1px solid rgba(0, 63, 74, 0.10)",
                            borderRadius: 4,
                            backgroundColor: "#ffff",
                            boxShadow: "0 24px 70px rgba(0, 0, 0, 0.28)",
                            alignItems: "stretch",
                            justifyContent: "flex-start",
                        }}
                    >
                        <Box
                            className="tw-flex tw-items-center tw-gap-4 tw-bg-gtr-sidebar tw-px-5 tw-py-4 tw-text-white"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                paddingX: { xs: 2, sm: 3 },
                                paddingY: 2,
                                fontFamily: "Prometo",
                                color: "#ffff",
                                backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                            }}
                        >
                            <Box
                                className="header-actions tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3"
                                sx={{
                                    fontFamily: "Prometo",
                                }}
                            >
                                <Box className="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
                                    <Box
                                        className="tw-flex tw-h-14 tw-w-14 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-bg-white/10"
                                        sx={{ width: 56, height: 56, flexShrink: 0, borderRadius: 3, backgroundColor: "rgba(255,255,255,0.10)" }}
                                    >
                                        <DirectionsCarFilledOutlined sx={{ fontSize: 30 }} />
                                    </Box>
                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography id="vehicle-map-filter-title" sx={{ color: "inherit", fontFamily: "Prometo", fontSize: { xs: 18, sm: 21 }, fontWeight: 700 }}>
                                            Filtro de veículos no mapa
                                        </Typography>
                                    </Box>
                                </Box>
                                <Tooltip title="Fechar" arrow placement="left">
                                    <IconButton
                                        aria-label="Fechar filtro de veículos"
                                        size="small"
                                        onClick={() => {
                                            actions.find((a) => a.name === "showCarsFilter")?.action(false);
                                        }}
                                        className="!tw-bg-white/10 !tw-text-white tw-transition-all tw-duration-200 hover:!tw-bg-red-500/70"
                                    >
                                        <CloseOutlined fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        <Box
                            className="vehicle-map-filter-content tw-grid tw-flex-1 tw-grid-cols-1 tw-gap-4 tw-overflow-y-auto tw-bg-white tw-p-4 sm:tw-p-6"
                            sx={{ width: "100%", flex: 1, overflowY: "auto", padding: { xs: 2, sm: 3 }, backgroundColor: "#ffff" }}
                        >
                            {!getCurrentUser.configs.isManager && <Box
                                className="tw-col-span-full"
                            >
                                <Autocomplete
                                    id="chip-label-select-group"
                                    className="input-select-group"
                                    sx={{ width: "100%" }}
                                    options={groupsList}
                                    value={groupsList.find((a) => a.name === groupName) ?? null}
                                    onChange={(_, value) => {
                                        setGroupName(value?.name ?? "");
                                    }}
                                    getOptionLabel={(option) => `${option.name}`}
                                    noOptionsText={"Nada encontrado"}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Grupo"
                                            variant="outlined"
                                            placeholder="Selecione um grupo"
                                            autoComplete="off"
                                            InputLabelProps={{ shrink: true }}
                                            sx={mapFilterFieldSx}
                                        />
                                    )}
                                />
                            </Box>}

                            <Box
                                className="tw-min-w-0"
                            >
                                <Autocomplete
                                    id="chip-label-select-brand"
                                    className="input-select-group"
                                    sx={{ width: "100%" }}
                                    options={vehicleBrandsList}
                                    value={vehicleBrandsList.find((a) => a.name === brandName) ?? null}
                                    onChange={(_, value) => {
                                        setBrandName(value?.name ?? "");
                                        setModelName("");
                                    }}
                                    getOptionLabel={(option) => `${option.name}`}
                                    noOptionsText={"Nada encontrado"}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Marca"
                                            variant="outlined"
                                            placeholder="Selecione uma marca"
                                            autoComplete="off"
                                            InputLabelProps={{ shrink: true }}
                                            sx={mapFilterFieldSx}
                                        />
                                    )}
                                />
                            </Box>

                            <Box
                                className="tw-min-w-0"
                            >
                                <Autocomplete
                                    id="chip-label-select-model"
                                    className="input-select-group"
                                    sx={{ width: "100%" }}
                                    options={vehicleModelsList}
                                    value={vehicleModelsList.find((a) => a.name === modelName) ?? null}
                                    onChange={(_, value) => {
                                        setModelName(value?.name ?? "");
                                    }}
                                    getOptionLabel={(option) => `${option.name}`}
                                    noOptionsText={"Nada encontrado"}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Modelo"
                                            variant="outlined"
                                            placeholder="Selecione um modelo"
                                            autoComplete="off"
                                            InputLabelProps={{ shrink: true }}
                                            sx={mapFilterFieldSx}
                                        />
                                    )}
                                />
                            </Box>

                            <Box
                                className="tw-min-w-0"
                            >
                                <Autocomplete
                                    id="chip-label-select-type"
                                    className="input-select-group"
                                    sx={{ width: "100%" }}
                                    options={vehicleTypesList}
                                    value={vehicleTypesList.find((a) => a.name === typeName) ?? null}
                                    onChange={(_, value) => {
                                        setTypeName(value?.name ?? "");
                                    }}
                                    getOptionLabel={(option) => `${option.name}`}
                                    noOptionsText={"Nada encontrado"}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Tipo"
                                            variant="outlined"
                                            placeholder="Selecione um tipo"
                                            autoComplete="off"
                                            InputLabelProps={{ shrink: true }}
                                            sx={mapFilterFieldSx}
                                        />
                                    )}
                                />
                            </Box>

                            <Box
                                className="tw-col-span-full tw-min-w-0"
                            >
                                <Autocomplete
                                    id="chip-label-select-vehicle"
                                    className="input-select-group"
                                    sx={{ width: "100%" }}
                                    options={filteredList}
                                    value={filteredList.find((a) => a.name === name) ?? null}
                                    onChange={(_, value) => {
                                        setName(value?.name ?? "");
                                    }}
                                    getOptionLabel={(option) => `${option?.name} - ${option?.vehiclePlate}(${option?.deviceImei ?? option?.satelliteImei ?? "Sem dispositivo"})`}
                                    noOptionsText={"Nada encontrado"}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Veículo"
                                            variant="outlined"
                                            placeholder="Selecione um veículo"
                                            autoComplete="off"
                                            InputLabelProps={{ shrink: true }}
                                            sx={mapFilterFieldSx}
                                        />
                                    )}
                                />
                            </Box>
                        </Box>
                        <Box
                            className="vehicle-map-filter-footer tw-flex tw-flex-col-reverse tw-gap-2 tw-border-t tw-border-black/10 tw-bg-white/70 tw-p-4 sm:tw-flex-row sm:tw-justify-end"
                            sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: { xs: "column-reverse", sm: "row" },
                                justifyContent: { sm: "flex-end" },
                                gap: 1,
                                padding: 2,
                                borderTop: "1px solid rgba(0,0,0,0.10)",
                                backgroundColor: "#ffff",
                            }}
                        >
                            <Button
                                type="button"
                                variant="contained"
                                startIcon={<CloseOutlined />}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        setBrandName("");
                                        setName("");
                                        setTypeName("");
                                        setModelName("");
                                        setGroupName("");
                                    }
                                }}
                                sx={{
                                    minWidth: 132,
                                    minHeight: 44,
                                    borderRadius: 2,
                                    color: "#ffff",
                                    backgroundColor: "#dc3545",
                                    fontFamily: "Prometo",
                                    textTransform: "none",
                                    boxShadow: "none",
                                    transition: "transform 200ms ease, box-shadow 200ms ease",
                                    "&:hover": {
                                        backgroundColor: "#dc3545",
                                        boxShadow: "0 8px 18px rgba(220,53,69,0.22)",
                                        transform: "translateY(-1px)",
                                    },
                                }}
                            >
                                Limpar
                            </Button>

                            <Button
                                type="button"
                                variant="contained"
                                startIcon={<SearchOutlined />}
                                onClick={() => {
                                    filter([groupName, brandName, modelName, typeName, name]);
                                }}
                                sx={{
                                    minWidth: 132,
                                    minHeight: 44,
                                    borderRadius: 2,
                                    color: "#ffff",
                                    backgroundColor: "#00B700",
                                    fontFamily: "Prometo",
                                    textTransform: "none",
                                    boxShadow: "none",
                                    transition: "transform 200ms ease, box-shadow 200ms ease",
                                    "&:hover": {
                                        backgroundColor: "#00B700",
                                        boxShadow: "0 8px 18px rgba(0,183,0,0.22)",
                                        transform: "translateY(-1px)",
                                    },
                                }}
                            >
                                Filtrar
                            </Button>
                        </Box>
                    </Paper>
                </Rmodal>
            </>
        );
    }, [
        actions,
        getCurrentUser.configs.isManager,
        brandName,
        groupName,
        groupsList,
        isToastVisible,
        showCarFilter,
        modelName,
        typeName,
        validationText,
        vehicleBrandsList,
        vehicleModelsList,
        vehicleTypesList,
        filteredList,
        filter,
        name
    ]);

    const memoizedPositions = useMemo(() => {
        if (checkedVehicles.length === 0) return filteredList;
        const checkedSet = new Set(checkedVehicles);
        return filteredList.filter(v => checkedSet.has(v.id));
    }, [filteredList, checkedVehicles]);

    useEffect(() => {
        setDismissNearbyPoints(false);
    }, [selectedVehicle.id]);

    const nearbyInterestPoints = useMemo(() => {
        if (!showInterestPoints) return [];
        if (selectedVehicle?.position?.lat === undefined || selectedVehicle?.position?.lng === undefined) return [];
        if (interestPointsList.length === 0) return [];

        return findNearestPoints(
            { lat: selectedVehicle.position.lat, lng: selectedVehicle.position.lng },
            interestPointsList,
            5
        );
    }, [showInterestPoints, selectedVehicle?.position?.lat, selectedVehicle?.position?.lng, interestPointsList]);

    // centraliza o mapa (Leaflet ou Google) no ponto de interesse clicado no painel de proximidade
    const focusMapOnPoint = useCallback((lat: number, lng: number) => {
        if (selectedMap === "gmaps") {
            mapRef.current?.panTo?.({ lat, lng });
            mapRef.current?.setZoom?.(16);
        } else {
            mapRef.current?.setView?.([lat, lng], 16);
        }
    }, [selectedMap]);

    const handleExportRouteWhatsApp = useCallback(() => {
        if (!nearbyRoute?.origin?.position || !nearbyRoute?.nearest?.position) return;

        const originCoords = `${nearbyRoute.origin.position.lat},${nearbyRoute.origin.position.lng}`;
        const destCoords = `${nearbyRoute.nearest.position.lat},${nearbyRoute.nearest.position.lng}`;
        const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${originCoords}&destination=${destCoords}&travelmode=driving`;

        const originLabel = nearbyRoute.origin.id === -1
            ? (nearbyRoute.origin.position?.address ?? "Endereço pesquisado")
            : `${nearbyRoute.origin.name} (${nearbyRoute.origin.vehiclePlate})`;

        const message =
            `*ROTA PARA VEÍCULO MAIS PRÓXIMO*\n\n` +
            `*Origem:* ${originLabel}\n` +
            `*Destino:* ${nearbyRoute.nearest.name} (${nearbyRoute.nearest.vehiclePlate})\n` +
            `*Distância:* ${nearbyRoute.distanceText}\n` +
            `*Tempo Estimado:* ${nearbyRoute.durationText}\n\n` +
            `*Siga a rota no Google Maps:*\n${mapsUrl}`;

        window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank");
    }, [nearbyRoute]);

    const isNearbyRouteOriginAddress = nearbyRoute?.origin.id === -1;

    const handleSearchNearestVehicleFromAddress = useCallback((point: { lat: number; lng: number; address: string }) => {
        const addressOrigin: VehicleGridType = {
            ...vehicleGridDefault,
            id: -1,
            name: "Endereço pesquisado",
            vehiclePlate: "",
            position: { ...vehicleGridDefault.position, lat: point.lat, lng: point.lng, address: point.address } as any,
        };

        if (selectedMap === "gmaps") {
            gPositionsMarkersRef.current?.focusOnNearbyFromPoint(addressOrigin);
        } else {
            openPositionsMarkersRef.current?.focusOnNearbyFromPoint(addressOrigin);
        }
    }, [selectedMap]);

    const attrs = useMemo(() => {
        try {
            return JSON.parse(selectedVehicle?.position?.attributes || '{}');
        } catch {
            return {};
        }
    }, [selectedVehicle?.position?.attributes]);

    const CarDetailsModal = useMemo(() => {
        const isImpersonating = isImpersonationLocked();
        const sendAutomaticCommands = Boolean(getCurrentUser.configs.customerSettings?.sendAutomaticCommands);
        const speedKm = formattedSpeed(selectedVehicle.position.speed);

        return (
            <>
                <Rmodal
                    open={isOpenCarsDetails}
                    hiddenBackdrop
                    style={{}}
                    toast={<Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);
                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />}
                >
                    <Paper
                        className="!tw-overflow-hidden !tw-rounded-2xl tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                        sx={{
                            ...style,
                            width: { xs: "calc(100vw - 24px)", sm: "min(92vw, 890px)" },
                            maxWidth: 890,
                            maxHeight: { xs: "calc(100dvh - 24px)", sm: "calc(100dvh - 48px)" },
                            p: 0,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "stretch",
                            justifyContent: "flex-start",
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            indicatorColor="primary"
                            textColor="inherit"
                            aria-label="icon tabs info"
                            className="tab-container vehicle-details-tabs"
                            sx={{
                                px: { xs: 0.5, sm: 1 },
                                flexShrink: 0,
                                borderBottom: "1px solid rgba(0, 108, 119, 0.12)",
                                bgcolor: "#fff",
                                fontSize: "18px",
                                fontFamily: "Prometo",
                                "& .MuiTab-root": {
                                    minHeight: 68,
                                    minWidth: { xs: 92, sm: 120 },
                                    transition: "color 180ms ease, background-color 180ms ease",
                                },
                                "& .MuiTab-root:hover": { bgcolor: "rgba(0, 183, 0, 0.05)" },
                                "& .MuiTabs-scrollButtons": { color: "#006C77" },
                            }}
                        >
                            <Tab icon={<Tooltip title="Informações do veículo" arrow><DirectionsCarFilledOutlined /></Tooltip>} aria-label="car-info" label="Veículo" sx={{ border: "none", fontSize: 10, fontFamily: "Prometo" }} />
                            <Tab icon={<Tooltip title="Informações do dispositivo" arrow><TapAndPlayOutlined /></Tooltip>} aria-label="device-info" label="Dispositivo" sx={{ border: "none", fontSize: 10, fontFamily: "Prometo" }} />
                            {selectedVehicle?.deviceImei && (
                                <Tab
                                    icon={<Tooltip title="Comandos" arrow><SendToMobileOutlined /></Tooltip>}
                                    disabled={!canViewCommands || isImpersonating}
                                    aria-label="device-info"
                                    label="Comandos"
                                    sx={{ border: "none", fontSize: 10, fontFamily: "Prometo" }}
                                />
                            )}
                            {selectedVehicle?.deviceImei && (
                                <Tab
                                    icon={<Tooltip title="Configurações de comandos automáticos" arrow><SettingsOutlined /></Tooltip>}
                                    disabled={!canViewCommands || !sendAutomaticCommands || isImpersonating}
                                    aria-label="device-info"
                                    label="Configurações"
                                    sx={{ border: "none", fontSize: 10, fontFamily: "Prometo" }}
                                />
                            )}
                            {selectedVehicle?.deviceImei && (
                                <Tab
                                    icon={<Tooltip title="Listagem de comandos automáticos salvos" arrow><AppShortcutOutlined /></Tooltip>}
                                    disabled={!canViewCommands || !sendAutomaticCommands || isImpersonating}
                                    aria-label="device-info"
                                    label="Comandos salvos"
                                    sx={{ border: "none", fontSize: 10, fontFamily: "Prometo" }}
                                />
                            )}
                        </Tabs>
                        <Paper
                            ref={vehicleDetailsContentRef}
                            className="vehicle-details-content"
                            sx={{
                                background: "#fff",
                                boxShadow: "none",
                                height: { xs: "calc(100dvh - 190px)", sm: "min(65dvh, 560px)" },
                                minHeight: 0,
                                overflowY: "auto",
                                px: { xs: 1.5, sm: 2 },
                                pb: 2,
                                "& .vehicle-information-grid": {
                                    display: "grid",
                                    gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))" },
                                    gap: 1,
                                    margin: "0 !important",
                                    padding: "12px 0",
                                },
                                "& .vehicle-information-grid > .MuiBox-root[class*='col-sm']": {
                                    width: "auto",
                                    maxWidth: "none",
                                    margin: "0 !important",
                                    padding: "12px !important",
                                    alignItems: "flex-start",
                                    border: "1px solid rgba(0, 108, 119, 0.12)",
                                    borderRadius: "10px",
                                    backgroundColor: "#f8fafc",
                                    transition: "border-color 180ms ease, box-shadow 180ms ease",
                                },
                                "& .vehicle-information-grid > .MuiBox-root[class*='col-sm']:hover": {
                                    borderColor: "rgba(0, 108, 119, 0.28)",
                                    boxShadow: "0 4px 14px rgba(9, 65, 74, 0.06)",
                                },
                                "& .vehicle-information-grid > .col-sm-12": {
                                    gridColumn: { sm: "1 / -1" },
                                },
                                "& .vehicle-information-grid > .MuiDivider-root": { display: "none" },
                                "& .vehicle-information-grid .MuiSvgIcon-root": {
                                    color: "#006C77",
                                    flexShrink: 0,
                                },
                                "& .vehicle-information-grid .MuiTypography-root": {
                                    overflowWrap: "anywhere",
                                },
                            }}
                        >
                            <Box
                                className="tw-sticky tw-top-0 tw-z-10 tw-bg-gradient-to-r tw-from-gtr-teal-dark tw-to-gtr-teal tw-shadow-md"
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1.5,
                                    width: "100%",
                                    minHeight: 52,
                                    mt: 1.25,
                                    borderRadius: 1.5,
                                    color: "#fff",
                                    px: { xs: 1.5, sm: 2 },
                                    py: 1,
                                }}
                            >
                                <Tooltip title={`${selectedVehicle.name} - ${selectedVehicle.vehiclePlate} (${selectedVehicle?.deviceImei ?? selectedVehicle?.satelliteImei})`} arrow placement="top">
                                    <Typography variant="body1" noWrap sx={{ fontWeight: 700, minWidth: 0, flex: 1 }}>
                                        {`${selectedVehicle.name} - ${selectedVehicle.vehiclePlate}(${selectedVehicle?.deviceImei ?? selectedVehicle?.satelliteImei})`}
                                    </Typography>
                                </Tooltip>

                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
                                    {value === 0 && (
                                        <Button
                                            size="small"
                                            startIcon={showDriverDetails ? <ArrowBackOutlined /> : <PersonOutlineOutlined />}
                                            onClick={() => setShowDriverDetails(previous => !previous)}
                                            sx={{ color: "#fff", border: "1px solid rgba(255,255,255,0.5)", fontSize: 11, whiteSpace: "nowrap" }}
                                        >
                                            {showDriverDetails ? "Voltar" : "Condutores"}
                                        </Button>
                                    )}
                                </Box>
                            </Box>

                            <TabPanel value={value} index={0}>
                                {showDriverDetails ? (
                                    <DriverChangeSummary
                                        key={selectedVehicle.id}
                                        vehicle={selectedVehicle}
                                        history={driverChangesByVehicle[selectedVehicle.id] ?? []}
                                        error={driverHistoryErrors[selectedVehicle.id]}
                                        loading={driverHistoryLoading[selectedVehicle.id]}
                                    />
                                ) : (
                                <Box className="row vehicle-information-grid">
                                    <Box
                                        className="col-sm-6"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <LocationCityOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Secretaria: </span>{" "}
                                            {selectedVehicle?.departmentSecretaryReducedName}
                                        </Typography>
                                    </Box>
                                    <Box
                                        className="col-sm-6"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <ReduceCapacityOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Departamento: </span>{" "}
                                            {selectedVehicle?.departmentReducedName}
                                        </Typography>
                                    </Box>
                                    <Divider style={{ background: "gray" }} />
                                    <Box
                                        className="col-sm-6"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <AbcOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Marca: </span>{" "}
                                            {selectedVehicle?.vehicleBrandName ?? "-"}
                                        </Typography>
                                    </Box>
                                    <Box
                                        className="col-sm-6"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <AbcOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Modelo: </span>{""}
                                            {selectedVehicle?.vehicleModelName ?? "-"}
                                        </Typography>
                                    </Box>
                                    <Divider style={{ background: "gray" }} />
                                    <Box
                                        className="col-sm-6"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <AbcOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Tipo: </span>{" "}
                                            {selectedVehicle?.vehicleTypeName}
                                        </Typography>
                                    </Box>

                                    <Box
                                        className="col-sm-6"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <SevenMpOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Placa: </span>{" "}
                                            {selectedVehicle?.vehiclePlate}
                                        </Typography>
                                    </Box>

                                    {selectedVehicle.position.protocol !== "globalstar" && <Divider style={{ background: "gray" }} />}
                                    {selectedVehicle.position.protocol !== "globalstar" && (() => {
                                        const voltage = Number(attrs?.power);
                                        const vehicleType = selectedVehicle?.vehicleTypeName?.toLowerCase();

                                        const heavyVehicles = ["caminhão", "ônibus", "ônibus escolar"];
                                        const isHeavy = heavyVehicles.includes(vehicleType);
                                        const limitVoltage = isHeavy ? 22 : 11;
                                        const isLow = voltage < limitVoltage;

                                        return (
                                            <>
                                                <Box
                                                    className="col-sm-12"
                                                    style={{
                                                        marginBottom: isLow ? 0 : 5,
                                                        padding: 10,
                                                        display: "flex",
                                                    }}
                                                >
                                                    <BatteryCharging20Outlined style={{ marginRight: 5 }} />
                                                    <Typography variant="body1">
                                                        <span style={{ fontWeight: "bold" }}>Bateria do veículo: </span>{" "}
                                                        {attrs?.power != null ? formatVoltage(attrs.power, "V") : "-"}
                                                    </Typography>
                                                </Box>

                                                {isLow && (
                                                    <Box
                                                        className="col-sm-12"
                                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                                    >
                                                        <Divider style={{ background: "gray" }} />
                                                        <Box
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontFamily: "Prometo",
                                                                margin: 0,
                                                            }}
                                                        >
                                                            <Alert
                                                                style={{
                                                                    borderRadius: 5,
                                                                    padding: 2,
                                                                }}
                                                                severity="warning"
                                                            >
                                                                A voltagem da bateria do veículo está abaixo do ideal, comunique-se com o suporte para análise.
                                                            </Alert>
                                                        </Box>
                                                    </Box>
                                                )}
                                            </>
                                        );
                                    })()}

                                    <Divider style={{ background: "gray" }} />
                                    <Box
                                        className="col-sm-12"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <EdgesensorHighOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Dispositivo GPRS: </span>{" "}
                                            {selectedVehicle?.deviceImei ?? "-"}
                                        </Typography>
                                    </Box>

                                    <Box
                                        className="col-sm-12"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <SatelliteAltOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Dispositivo satélite: </span>{" "}
                                            {selectedVehicle?.satelliteImei ?? "-"}
                                        </Typography>
                                    </Box>

                                    <Box
                                        className="col-sm-6"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <GroupsOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Grupos: </span>{" "}
                                            {selectedVehicle?.groups?.map((name) => name).toString().replaceAll(",", ", ")}
                                        </Typography>
                                    </Box>
                                </Box>
                                )}
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                <Box className="row vehicle-information-grid">
                                    {getCurrentUser.configs.isManager && selectedVehicle?.zonedSatelliteLastUpdate && (
                                        <Box
                                            className="col-sm-12"
                                            style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                        >
                                            <ManageHistoryOutlined style={{ marginRight: 5 }} />
                                            <Typography variant="body1">
                                                <span style={{ fontWeight: "bold" }}>Última comunicação servidor satelital </span>{" "}
                                                {selectedVehicle?.zonedSatelliteLastUpdate ? `${dayjs(selectedVehicle?.zonedSatelliteLastUpdate).format(
                                                    "DD/MM/YYYY"
                                                )} às ${dayjs(selectedVehicle?.zonedSatelliteLastUpdate).format(
                                                    "HH:mm:ss"
                                                )}` : "-"}
                                            </Typography>
                                        </Box>
                                    )}
                                    <Divider style={{ background: "gray" }} />

                                    {getCurrentUser.configs.isManager && (
                                        <Box
                                            className="col-sm-12"
                                            style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                        >
                                            <ManageHistoryOutlined style={{ marginRight: 5 }} />
                                            <Typography variant="body1">
                                                <span style={{ fontWeight: "bold" }}>Última comunicação servidor GPRS </span>{" "}
                                                {selectedVehicle?.zonedDeviceLastUpdate ? `${dayjs(selectedVehicle?.zonedDeviceLastUpdate).format(
                                                    "DD/MM/YYYY"
                                                )} às ${dayjs(selectedVehicle?.zonedDeviceLastUpdate).format(
                                                    "HH:mm:ss"
                                                )}` : "-"}
                                            </Typography>
                                        </Box>
                                    )}
                                    <Divider style={{ background: "gray" }} />

                                    <Box
                                        className="col-sm-12"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <ManageHistoryOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Última posição enviada: </span>{" "}
                                            {`${dayjs(selectedVehicle.position.zonedFixTime).tz(getTimezone(selectedVehicle.utcZone ?? "")).format(
                                                "DD/MM/YYYY"
                                            )} às ${dayjs(selectedVehicle.position.zonedFixTime).tz(getTimezone(selectedVehicle.utcZone ?? "")).format(
                                                "HH:mm:ss"
                                            )} - ${(selectedVehicle.position.protocol === "teltonika" || selectedVehicle.position.protocol === "rst" || selectedVehicle.position.protocol === "teltonikamqtt") ? "GPRS" : selectedVehicle.position.protocol}`}
                                        </Typography>
                                    </Box>

                                    <Divider style={{ background: "gray" }} />
                                    <Box
                                        className="col-sm-12"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <FmdGoodOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Última coordenada enviada: </span>{" "}
                                            {` ${selectedVehicle.position.lat} | ${selectedVehicle.position.lng}`}
                                        </Typography>
                                    </Box>
                                    {selectedVehicle.position.protocol !== "globalstar" && <Divider style={{ background: "gray" }} />}
                                    {selectedVehicle.position.protocol !== "globalstar" && (
                                        <Box
                                            className="col-sm-12"
                                            style={{ marginBottom: 0, padding: 10, display: "flex" }}
                                        >
                                            <BatteryCharging20Outlined style={{ marginRight: 5 }} />
                                            <Typography variant="body1">
                                                <span style={{ fontWeight: "bold" }}>Bateria dispositivo: </span>{" "}
                                                {attrs?.battery != null
                                                    ? formatVoltage(attrs.battery, "V")
                                                    : attrs?.batteryLevel != null
                                                        ? formatVoltage(attrs.batteryLevel, "%")
                                                        : "-"}
                                            </Typography>
                                        </Box>
                                    )}
                                    {selectedVehicle.position.protocol !== "globalstar" && attrs.battery && attrs.battery <= 3 && (
                                        <Box
                                            className="col-sm-12"
                                            style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                        >
                                            <Divider style={{ background: "gray" }} />
                                            <Box style={{ display: "flex", alignItems: "center", fontFamily: "Prometo", margin: 0 }}>
                                                <Alert
                                                    style={{
                                                        borderRadius: 5,
                                                        padding: 2
                                                    }}
                                                    severity="warning"
                                                >
                                                    A voltagem da bateria do dispositivo está abaixo do ideal, comunique-se com o suporte para análise.
                                                </Alert>
                                            </Box>
                                        </Box>
                                    )}

                                    <Divider style={{ background: "gray" }} />
                                    <Box
                                        className="col-sm-12"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <MyLocationOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Endereço: </span>{" "}
                                            {`${selectedVehicle.position.address ?? "Sem endereço"}`}
                                        </Typography>
                                    </Box>
                                    <Divider style={{ background: "gray" }} />
                                    <Box
                                        className="col-sm-12"
                                        style={{ marginBottom: 5, padding: 10, display: "flex" }}
                                    >
                                        <SpeedOutlined style={{ marginRight: 5 }} />
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: "bold" }}>Velocidade: </span>{" "}
                                            {`${speedKm}`}
                                        </Typography>
                                    </Box>
                                </Box>
                            </TabPanel>

                            <TabPanel value={value} index={2} className="row" style={{ position: "relative" }}>
                                {loading && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "rgba(255, 255, 255, 0.85)",
                                            zIndex: 10,
                                            borderRadius: 1,
                                            gap: 2,
                                        }}
                                    >
                                        <CircularProgress size={40} sx={{ color: "#0FB403" }} />
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontFamily: "Prometo",
                                                color: "#333",
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Aguardando resposta...
                                        </Typography>
                                    </Box>
                                )}
                                <Box
                                    className="col-md-12"
                                    style={{ margin: "15px 0px 0px 0px", minHeight: 200 }}
                                >
                                    <Autocomplete
                                        id="chip-label-select-command"
                                        className="input-select-command"
                                        style={{
                                            width: "100%",
                                            backgroundColor: "#ffffff29",
                                            borderColor: "lightgray",
                                        }}
                                        onChange={(_, value) => {
                                            setDeviceCommandName(value?.description ?? "");
                                        }}
                                        options={deviceCommandsList}
                                        loading={loadingCommands}
                                        loadingText="Carregando comandos..."
                                        disabled={!canViewCommands || loading || isImpersonating}
                                        value={deviceCommandsList.find((a) => a.description === deviceCommandName) ?? null}
                                        getOptionLabel={(option) => `${option.description} - (${option.type})`}
                                        noOptionsText={"Nada encontrado"}
                                        renderInput={(params) => (
                                            <FormControl
                                                className="form-group"
                                                style={{ display: "flex" }}
                                            >
                                                <InputLabel
                                                    id="vehicles-label"
                                                    required
                                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                    shrink
                                                >
                                                    Comando
                                                </InputLabel>
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Selecione um comando"
                                                    autoComplete="off"
                                                    required
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        notched: true,
                                                        label: "Comando",
                                                        classes: {
                                                            notchedOutline: "custom-notch",
                                                        },
                                                    }}
                                                />
                                            </FormControl>
                                        )}
                                    />

                                    <Paper
                                        elevation={0}
                                        style={{
                                            display: "flex",
                                            justifyContent: "start",
                                            alignItems: "start",
                                            background: "transparent",
                                        }}
                                    >
                                        <Button
                                            type="button"
                                            style={{ fontFamily: "Prometo", color: "#ffff", marginTop: 10 }}
                                            disabled={!canSendCommands || !deviceCommandName || loading || loadingCommands || isImpersonating}
                                            onClick={() => {
                                                onSendCommand();
                                            }}
                                            className="btn btn-primary btn-block login-button"
                                        >
                                            <SendTwoTone style={{ marginRight: 5 }} />
                                            <Typography
                                                className="forgot-password"
                                                style={{
                                                    fontFamily: "Prometo",
                                                    fontSize: "16px",
                                                    color: "#ffff",
                                                }}
                                            >
                                                Enviar
                                            </Typography>
                                        </Button>
                                    </Paper>

                                    {mqttCommandDelivery && (
                                        <Alert
                                            severity={mqttCommandStatusInfo.severity === "warn" ? "warning" : mqttCommandStatusInfo.severity}
                                            sx={{
                                                mt: 1,
                                                alignItems: "flex-start",
                                                ...getMqttCommandStatusCardStyle(mqttCommandStatusInfo.severity),
                                            }}
                                        >
                                            <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "Prometo" }}>
                                                {mqttCommandStatusInfo.label}
                                            </Typography>
                                            <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                Comando: {mqttCommandDelivery.description || "Não informado"}
                                            </Typography>
                                            <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                ID do envio: {mqttCommandDelivery.commandId}
                                            </Typography>
                                            {mqttCommandDelivery.response && (
                                                <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                    Resposta: {mqttCommandDelivery.response}
                                                </Typography>
                                            )}
                                            {mqttCommandDelivery.error && (
                                                <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                    Erro: {mqttCommandDelivery.error}
                                                </Typography>
                                            )}
                                            {mqttCommandDelivery.respondedAt && (
                                                <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                    Atualizado em: {mqttCommandDelivery.respondedAt}
                                                </Typography>
                                            )}
                                        </Alert>
                                    )}
                                </Box>
                            </TabPanel>

                            <TabPanel value={value} index={3} className="row">
                                <Box
                                    className="col-md-12"
                                    style={{ margin: "15px 0px 0px 0px", height: 200 }}
                                >
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex", marginBottom: 20 }}
                                    >
                                        <InputLabel
                                            id="event-type-label"
                                            style={{ color: "black", fontFamily: "Prometo" }}
                                            shrink
                                        >
                                            Evento
                                        </InputLabel>
                                        <Select
                                            id="chip-label-select-event"
                                            name="eventType"
                                            className="form-control input-select-city"
                                            labelId="event-type-label"
                                            label={"Evento"}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "#ffffff29",
                                                borderColor: "lightgray",
                                            }}
                                            displayEmpty
                                            input={
                                                <OutlinedInput
                                                    id="select-chip-select-event"
                                                    label={"Evento"}
                                                    style={{ borderColor: "gray" }}
                                                    notched
                                                />
                                            }
                                            renderValue={(item) => (
                                                <Chip
                                                    key={item}
                                                    style={{
                                                        color: "black",
                                                        width: 200,
                                                        fontFamily: "Prometo",
                                                    }}
                                                    label={item || "Selecione um evento"}
                                                />
                                            )}
                                            value={eventTypeName}
                                            onChange={(event: SelectChangeEvent) => {
                                                setEventTypeName(event.target.value);
                                            }}
                                        >
                                            {eventTypesList.map((item, i) => (
                                                <MenuItem key={item.id + i} value={item.name}>
                                                    {`${item.description} - (${item.name})`}
                                                </MenuItem>
                                            ))}
                                            <MenuItem key={"noselect"} value={""}>
                                                Selecione um evento
                                            </MenuItem>
                                        </Select>
                                    </FormControl>

                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex" }}
                                    >
                                        <InputLabel
                                            id="command-label"
                                            style={{ color: "black", fontFamily: "Prometo" }}
                                            shrink
                                        >
                                            Comando
                                        </InputLabel>
                                        <Select
                                            id="chip-label-select-command-auto"
                                            name="commandAuto"
                                            className="form-control input-select-city"
                                            labelId="command-label"
                                            label={"Comando"}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "#ffffff29",
                                                borderColor: "lightgray",
                                            }}
                                            displayEmpty
                                            input={
                                                <OutlinedInput
                                                    id="select-chip-select-command"
                                                    label={"Comando"}
                                                    style={{ borderColor: "gray" }}
                                                    notched
                                                />
                                            }
                                            renderValue={(item) => (
                                                <Chip
                                                    key={item}
                                                    style={{
                                                        color: "black",
                                                        width: 200,
                                                        fontFamily: "Prometo",
                                                    }}
                                                    label={item || "Selecione um comando"}
                                                />
                                            )}
                                            value={deviceCommandName}
                                            onChange={(event: SelectChangeEvent) => {
                                                setDeviceCommandName(event.target.value);
                                            }}
                                        >
                                            {deviceCommandsList.map((item, i) => (
                                                <MenuItem key={item.id + i} value={item.type}>
                                                    {`${item.description} - (${item.type})`}
                                                </MenuItem>
                                            ))}
                                            <MenuItem key={"noselect"} value={""}>
                                                Selecione um comando
                                            </MenuItem>
                                        </Select>
                                        <Paper
                                            elevation={0}
                                            style={{
                                                display: "flex",
                                                justifyContent: "start",
                                                alignItems: "start",
                                                background: "transparent",
                                            }}
                                        >
                                            <Button
                                                type="button"
                                                style={{ fontFamily: "Prometo", color: "#ffff", marginTop: 10 }}
                                                disabled={!deviceCommandName || !eventTypeName || isImpersonating}
                                                onClick={() => {
                                                    onSaveAutomaticEventAction();
                                                }}
                                                className="btn btn-primary btn-block login-button"
                                            >
                                                <SaveOutlined style={{ marginRight: 5 }} />
                                                <Typography
                                                    className="forgot-password"
                                                    style={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "16px",
                                                        color: "#ffff",
                                                    }}
                                                >
                                                    Salvar
                                                </Typography>
                                            </Button>
                                        </Paper>
                                    </FormControl>
                                </Box>
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <GridTemplate
                                    columns={columns}
                                    style={{ marginTop: 0, paddingRight: "2px", paddingLeft: "2px" }}
                                    headerName=""
                                    isHiddenMenu={isHiddenMenu}
                                    isLoading={false}
                                    order={"asc"}
                                    rows={rowsOptions(deviceActionList.map((item) => ({ ...item, commandId: deviceCommandsList.find((a) => a.id === item.commandId)?.type })), onUpdateStatus)}
                                    handleNext={(activated: string, page: number, size: number) => getAllEventActionsByDevice(activated, page, size)}
                                    handlePrevious={() => { }}
                                    isLastPage={isLastPage}
                                    totalPerPage={numberOfElementsPerPage}
                                    currentPage={pageNumber}
                                    totalElements={numberOfElements}
                                    sortField="name"
                                    withFilter={false}
                                    withOptions={true}
                                    query={""}
                                    setQuery={() => { }}
                                    filterPlaceholder={""}
                                    onRefresh={async () => { }}
                                    onExport={async (type: string) => { }}
                                    disableAddButton={true}
                                    disableReportButton={true}
                                    containerHeight="550px"
                                    contentHeight="400px"
                                    onAdd={() => { }}
                                    onClickRow={(item: any) => {
                                        setSelectedEventAction(item);
                                    }}
                                />
                            </TabPanel>
                        </Paper>
                        <Box
                            className="vehicle-details-footer tw-flex-none tw-border-t tw-border-gtr-border tw-bg-gtr-surface-muted"
                            sx={{
                                px: { xs: 1.5, sm: 2 },
                                py: 1.5,
                                borderTopColor: "rgb(var(--gtr-border))",
                                bgcolor: "rgb(var(--gtr-surface-muted))",
                                flexShrink: 0,
                            }}
                        >
                            <Paper
                                elevation={0}
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center",
                                    background: "transparent",
                                }}
                            >
                                <Button
                                    type="button"
                                    style={{ fontFamily: "Prometo", color: "#ffff" }}
                                    onClick={() => {
                                        setIsOpenCarsDetails(false);
                                        setShowDriverDetails(false);
                                        handleClose();
                                        setValue(0);
                                    }}
                                    className="btn btn-primary btn-block login-button-close tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-shadow-lg"
                                >
                                    <CloseOutlined style={{ marginRight: 5 }} />
                                    <Typography
                                        className="forgot-password"
                                        style={{
                                            fontFamily: "Prometo",
                                            fontSize: "16px",
                                            color: "#ffff",
                                        }}
                                    >
                                        Fechar
                                    </Typography>
                                </Button>
                            </Paper>
                        </Box>
                    </Paper>
                </Rmodal>
            </>
        );
    }, [canViewCommands, canSendCommands, loadingCommands, loading, getCurrentUser.configs.isManager, getCurrentUser.configs.customerSettings?.sendAutomaticCommands, getAllEventActionsByDevice, attrs.battery, attrs.batteryLevel, attrs.power, isLastPage, numberOfElements, numberOfElementsPerPage, pageNumber, deviceActionList, onUpdateStatus, handleClose, toastModalRef, validationText, isOpenCarsDetails, selectedVehicle, value, showDriverDetails, onSendCommand, deviceCommandName, deviceCommandsList, eventTypeName, eventTypesList, isHiddenMenu, onSaveAutomaticEventAction, mqttCommandDelivery, mqttCommandStatusInfo, driverChangesByVehicle, driverHistoryErrors, driverHistoryLoading]);

    return (
        <Box
            sx={{
                position: isHiddenMenu ? "static" : "relative",
                transition: "all 0.5s ease-out allow-discrete",
            }}
        >
            <DrawerBottomList
                isHiddenMenu={isHiddenMenu}
                isFixedMenu={isFixedMenu}
                isMenuOverlayOpen={isMenuOverlayOpen}
                onRefresh={() => setRefreshVersion(value => value + 1)}
                list={filteredList}
                setIsOpenCarsDetails={setIsOpenCarsDetails}
                setSelectedVehicle={setSelectedVehicle}
                onSelectRow={(item) => {
                    setSelectedVehicle(item);
                    setFollowRequest((value) => value + 1);
                }}
                onSelectionChange={(selectedIds) => setCheckedVehicles(selectedIds)}
                selectedVehicles={checkedVehicles}
            >
                <>
                    {loading && !isLiveMode && (
                        <Box
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                zIndex: 1100,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontFamily: "Prometo",
                            }}
                        >
                            <div className="loadingio-spinner-magnify-2by998twmg8">
                                <div className="ldio-yzaezf3dcmj">
                                    <div><div><div></div><div></div></div></div>
                                </div>
                            </div>
                        </Box>
                    )}

                    {CarDetailsModal}
                    {FiltersModal}
                    {MapChangerModal}

                    <MapSearch
                        withToolbar={true}
                        loading={loading}
                        selectedMap={selectedMap}
                        setLoading={setLoading}
                        setShowMapSearch={(value: boolean) =>
                            actions.find((a) => a.name === "showMapSearch")?.action(value)
                        }
                        style={style}
                        isOpen={showSearch}
                        mapRef={mapRef}
                        onSearchNearestVehicle={handleSearchNearestVehicleFromAddress}
                    />

                    {selectedMap === "gmaps" && (
                        <GPositionsMap
                            mapRef={mapRef}
                            center={{
                                lng:
                                    getCurrentUser?.configs?.customerSettings?.lng ??
                                    -56.0991301,
                                lat:
                                    getCurrentUser?.configs?.customerSettings?.lat ??
                                    -15.5986686,
                            }}
                            style={{
                                height: "100vh",
                                width: "100vw",
                                transition: "all 0.5s ease-out allow-discrete",
                            }}
                        >
                            <>
                                <GPositionsMarkers
                                    ref={gPositionsMarkersRef}
                                    followRequest={followRequest}
                                    gridSelected={selectedVehicle}
                                    positions={memoizedPositions}
                                    setActions={(item: VehicleGridType) => {
                                        setSelectedVehicle(item);
                                        setShowDriverDetails(false);
                                        setIsOpenCarsDetails(true);
                                    }}
                                    setValue={setValue}
                                    onLiveModeChange={setLiveVehicleId}
                                    liveVehicleId={liveVehicleId}
                                    routeToken={cookies.token || sessionStorage.getItem("token") || ""}
                                    routeCustomerId={(getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.customerId : cookies.selectedParameters?.customer?.id) ?? -1}
                                    driverChanges={liveVehicleId !== null ? driverChangesByVehicle[liveVehicleId] : []}
                                    driverHistoryLoading={liveVehicleId !== null && driverHistoryLoading[liveVehicleId]}
                                    driverHistoryError={liveVehicleId !== null && driverHistoryErrors[liveVehicleId]}
                                    useTransparentBackGround={getCurrentUser?.configs?.customerSettings?.useTransparentBackground}
                                    activeNearbyOriginId={nearbyRoute ? String(nearbyRoute.origin.id) : null}
                                    onNearbyRouteChange={setNearbyRoute}
                                />
                                {geofencesMapList.map((item) => item)}
                                {interestPointsGoogleMapList.map((item) => item)}
                            </>
                        </GPositionsMap>
                    )}

                    {selectedMap === "leaflet" && (
                        <MapContainer
                            id="leaflet-container"
                            center={{
                                lng:
                                    getCurrentUser?.configs?.customerSettings?.lng ??
                                    -56.0991301,
                                lat:
                                    getCurrentUser?.configs?.customerSettings?.lat ??
                                    -15.5986686,
                            }}
                            ref={(ref) => (mapRef.current = ref)}
                            style={{
                                height: "100vh",
                                width: "100vw",
                                transition: "all 0.5s ease-out allow-discrete",
                            }}
                            boxZoom={true}
                            zoomControl={false}
                            zoom={15}
                        >
                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />

                            <OpenPositionsMarkers
                                ref={openPositionsMarkersRef}
                                gridSelected={selectedVehicle}
                                positions={memoizedPositions}
                                setActions={(item: VehicleGridType) => {
                                    setSelectedVehicle(item);
                                    setShowDriverDetails(false);
                                    setIsOpenCarsDetails(true);
                                }}
                                setValue={setValue}
                                useTransparentBackGround={getCurrentUser?.configs?.customerSettings?.useTransparentBackground}
                                activeNearbyOriginId={nearbyRoute ? String(nearbyRoute.origin.id) : null}
                                onNearbyRouteChange={setNearbyRoute}
                            />

                            <FeatureGroup>
                                {geofencesMapList.map((item) => item)}
                                {interestPointsMapList.map((item) => item)}
                            </FeatureGroup>
                        </MapContainer>
                    )}

                    {nearbyRoute && (
                        <Paper
                            elevation={8}
                            className="nearby-vehicle-card tw-flex tw-flex-col tw-overflow-hidden tw-border tw-border-slate-200/80 tw-bg-white/95 tw-font-prometo tw-shadow-xl tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-gtr-smooth dark:tw-border-slate-700 dark:tw-bg-slate-900/95"
                            sx={{
                                position: "absolute",
                                top: { xs: 64, sm: 67 },
                                right: { xs: 64, sm: 72 },
                                left: { xs: 8, sm: "auto" },
                                width: { xs: "auto", sm: 340 },
                                maxHeight: { xs: "calc(100vh - 136px)", sm: "calc(100vh - 150px)" },
                                borderRadius: { xs: 2.5, sm: 3 },
                                zIndex: 1105,
                            }}
                        >
                            <Box
                                className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-bg-gtr-sidebar tw-px-3.5 tw-py-3 tw-text-white"
                                sx={{
                                    minHeight: 58,
                                }}
                            >
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: "inherit",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.75,
                                            fontSize: 13,
                                            fontFamily: "Prometo",
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        <NearMeOutlined sx={{ fontSize: 19 }} /> VEÍCULO MAIS PRÓXIMO
                                    </Typography>
                                    <Typography noWrap sx={{ fontSize: 10.5, fontWeight: 700, color: "rgba(255,255,255,0.72)", mt: 0.45, fontFamily: "Prometo" }}>
                                        MELHOR ROTA ENTRE OS VEÍCULOS
                                    </Typography>
                                </Box>

                                <Box className="tw-flex tw-flex-none tw-items-center tw-gap-1.5">
                                    <Tooltip title="Exportar rota via WhatsApp" arrow placement="top">
                                        <IconButton
                                            onClick={handleExportRouteWhatsApp}
                                            size="small"
                                            aria-label="Exportar rota via WhatsApp"
                                            className="!tw-bg-white/10 !tw-text-white tw-transition-all tw-duration-200 hover:!tw-bg-[#25D366]"
                                        >
                                            <WhatsApp fontSize="small" />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Fechar" arrow placement="top">
                                        <IconButton
                                            onClick={() => setNearbyRoute(null)}
                                            size="small"
                                            aria-label="Fechar rota do veículo mais próximo"
                                            className="!tw-bg-white/10 !tw-text-white tw-transition-all tw-duration-200 hover:!tw-bg-red-500/70"
                                        >
                                            <CloseOutlined fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>

                            <Box
                                className="nearby-vehicle-summary tw-grid tw-grid-cols-2 tw-divide-x tw-divide-slate-200 tw-border-b tw-border-slate-200 tw-bg-slate-50 dark:tw-divide-slate-700 dark:tw-border-slate-700 dark:tw-bg-slate-950"
                                sx={{
                                    "& > div": { px: 1.75, py: 1.15 },
                                }}
                            >
                                <Box>
                                    <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#64748b", fontFamily: "Prometo" }}>
                                        TEMPO ESTIMADO
                                    </Typography>
                                    <Typography sx={{ mt: 0.25, fontSize: 13, fontWeight: 800, color: "#09414a", fontFamily: "Prometo" }}>
                                        {nearbyRoute.durationText}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#64748b", fontFamily: "Prometo" }}>
                                        DISTÂNCIA TOTAL
                                    </Typography>
                                    <Typography sx={{ mt: 0.25, fontSize: 13, fontWeight: 800, color: "#00a100", fontFamily: "Prometo" }}>
                                        {nearbyRoute.distanceText}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                className="tw-overflow-y-auto tw-p-2.5"
                                sx={{
                                    scrollbarWidth: "thin",
                                    scrollbarColor: "#94a3b8 transparent",
                                    "&::-webkit-scrollbar": { width: 5 },
                                    "&::-webkit-scrollbar-thumb": { backgroundColor: "#94a3b8", borderRadius: 8 },
                                }}
                            >
                                <Box className="nearby-vehicle-route tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white dark:tw-border-slate-700 dark:tw-bg-slate-900">
                                    <Box className="tw-flex tw-items-start tw-gap-2.5 tw-border-b tw-border-slate-200 tw-px-3 tw-py-2.5">
                                        <Box className="tw-mt-0.5 tw-flex tw-h-7 tw-w-7 tw-flex-none tw-items-center tw-justify-center tw-rounded-lg tw-bg-gtr-teal-dark/10">
                                            <PlaceOutlined sx={{ fontSize: 16, color: "#09414a" }} />
                                        </Box>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#64748b", fontFamily: "Prometo" }}>
                                                {isNearbyRouteOriginAddress ? "INÍCIO · ENDEREÇO PESQUISADO" : "INÍCIO · VEÍCULO DE ORIGEM"}
                                            </Typography>
                                            <Typography noWrap sx={{ mt: 0.2, fontSize: 12.5, fontWeight: 800, color: "#263b40", fontFamily: "Prometo" }}>
                                                {isNearbyRouteOriginAddress
                                                    ? "Endereço pesquisado"
                                                    : `${nearbyRoute.origin.name} · ${nearbyRoute.origin.vehiclePlate}`}
                                            </Typography>
                                            <Tooltip
                                                title={nearbyRoute.origin.position?.address ??
                                                    (nearbyRoute.origin.position
                                                        ? `${nearbyRoute.origin.position.lat}, ${nearbyRoute.origin.position.lng}`
                                                        : "Sem endereço disponível")}
                                                arrow
                                                placement="left"
                                            >
                                                <Typography
                                                    sx={{
                                                        mt: 0.35,
                                                        fontSize: 10.5,
                                                        color: "#64748b",
                                                        lineHeight: 1.35,
                                                        wordBreak: "break-word",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        fontFamily: "Prometo",
                                                    }}
                                                >
                                                    {nearbyRoute.origin.position?.address ??
                                                        (nearbyRoute.origin.position
                                                            ? `${nearbyRoute.origin.position.lat}, ${nearbyRoute.origin.position.lng}`
                                                            : "Sem endereço disponível")}
                                                </Typography>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                    <Box className="tw-flex tw-items-start tw-gap-2.5 tw-bg-gtr-green/[0.025] tw-px-3 tw-py-2.5">
                                        <Box className="tw-mt-0.5 tw-flex tw-h-7 tw-w-7 tw-flex-none tw-items-center tw-justify-center tw-rounded-lg tw-bg-gtr-green/10">
                                            <FmdGoodOutlined sx={{ fontSize: 16, color: "#00a100" }} />
                                        </Box>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: "#00a100", fontFamily: "Prometo" }}>
                                                DESTINO · MAIS PRÓXIMO ENCONTRADO
                                            </Typography>
                                            <Typography noWrap sx={{ mt: 0.2, fontSize: 12.5, fontWeight: 800, color: "#263b40", fontFamily: "Prometo" }}>
                                                {`${nearbyRoute.nearest.name} · ${nearbyRoute.nearest.vehiclePlate}`}
                                            </Typography>
                                            <Tooltip
                                                title={nearbyRoute.nearest.position?.address ??
                                                    (nearbyRoute.nearest.position
                                                        ? `${nearbyRoute.nearest.position.lat}, ${nearbyRoute.nearest.position.lng}`
                                                        : "Sem endereço disponível")}
                                                arrow
                                                placement="left"
                                            >
                                                <Typography
                                                    sx={{
                                                        mt: 0.35,
                                                        fontSize: 10.5,
                                                        color: "#64748b",
                                                        lineHeight: 1.35,
                                                        wordBreak: "break-word",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        fontFamily: "Prometo",
                                                    }}
                                                >
                                                    {nearbyRoute.nearest.position?.address ??
                                                        (nearbyRoute.nearest.position
                                                            ? `${nearbyRoute.nearest.position.lat}, ${nearbyRoute.nearest.position.lng}`
                                                            : "Sem endereço disponível")}
                                                </Typography>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Paper>
                    )}

                    {nearbyInterestPoints.length > 0 && !dismissNearbyPoints && (
                        <Paper
                            elevation={8}
                            sx={{
                                position: "absolute",
                                top: 50,
                                left: 100,
                                width: 320,
                                maxHeight: "70vh",
                                background: "rgba(255, 255, 255, 0.95)",
                                backdropFilter: "blur(16px)",
                                borderRadius: "20px",
                                display: "flex",
                                flexDirection: "column",
                                zIndex: 1105,
                                overflow: "hidden",
                                border: "1px solid rgba(0,0,0,0.05)",
                            }}
                        >
                            {/* Cabeçalho */}
                            <Box
                                sx={{
                                    p: 2,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    background:
                                        "linear-gradient(135deg, rgba(9, 65, 74, 0.1) 0%, rgba(9, 65, 74, 0.02) 100%)",
                                }}
                            >
                                <Box>
                                    <Typography
                                        sx={{
                                            fontWeight: "800",
                                            color: "rgb(9, 65, 74)",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            fontSize: 13,
                                            fontFamily: "Prometo",
                                        }}
                                    >
                                        <PlaceOutlined fontSize="small" /> PONTOS PRÓXIMOS
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 10,
                                            color: "text.secondary",
                                            mt: 0.3,
                                            fontFamily: "Prometo",
                                        }}
                                    >
                                        {`${selectedVehicle.name} - ${selectedVehicle.vehiclePlate}`}
                                    </Typography>
                                </Box>
                                <IconButton
                                    onClick={() => setDismissNearbyPoints(true)}
                                    size="small"
                                    title="Fechar"
                                    sx={{
                                        color: "#f44336",
                                        background: "rgba(244,67,54,0.1)",
                                        "&:hover": { background: "rgba(244,67,54,0.2)" },
                                    }}
                                >
                                    <CloseOutlined fontSize="small" />
                                </IconButton>
                            </Box>

                            <Divider />

                            {/* Lista ordenada por distância */}
                            <Box sx={{ overflowY: "auto", p: 1 }}>
                                {nearbyInterestPoints.map((item) => (
                                    <Box
                                        key={item.id}
                                        onClick={() => focusMapOnPoint(item.latitude, item.longitude)}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            p: 1,
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            "&:hover": { background: "rgba(9,65,74,0.05)" },
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                                            <Box
                                                sx={{
                                                    width: 10,
                                                    height: 10,
                                                    borderRadius: "50%",
                                                    background: item.color || "#003f4a",
                                                    flexShrink: 0,
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontSize: 12,
                                                    fontFamily: "Prometo",
                                                    fontWeight: 600,
                                                    color: "#2c3e50",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {item.name}
                                            </Typography>
                                        </Box>
                                        <Chip
                                            size="small"
                                            label={`${item.distanceKm.toFixed(item.distanceKm < 1 ? 2 : 1)} km`}
                                            sx={{
                                                fontSize: 10,
                                                fontFamily: "Prometo",
                                                fontWeight: 700,
                                                background: "rgba(0,183,0,0.15)",
                                                color: "#00B700",
                                                ml: 1,
                                                flexShrink: 0,
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Paper>
                    )}

                    {showInterestPoints && interestPointsList.length > 0 && (
                        <Box
                            className="share-interest-points-button"
                            sx={{
                                position: "absolute",
                                color: "#ffff",
                                zIndex: 99999,
                                background: "rgb(0, 63, 74)",
                                right: 10,
                                top: 340,
                                borderRadius: 2,
                            }}
                        >
                            <IconButton
                                title="Compartilhar todos os pontos de interesse ativos via WhatsApp"
                                onClick={() => {
                                    const activePoints = interestPointsList.filter((item) => item.activated);
                                    if (activePoints.length === 0) return;
                                    openWhatsAppShare(buildAllInterestPointsShareMessage(activePoints));
                                }}
                                style={{ transition: "all 0.8s ease-out allow-discrete" }}
                            >
                                <WhatsApp style={{ color: "#25D366" }} />
                            </IconButton>
                        </Box>
                    )}

                    <Box
                        style={{
                            position: "absolute",
                            top: 5,
                            right: 100,
                            width: "300px",
                            padding: 5,
                            borderRadius: "5px",
                            backgroundColor: "rgba(0, 63, 74, 0.62)",
                            zIndex: 1100,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontFamily: "Prometo",
                            color: "#ffff"
                        }}
                    >
                        <Typography style={{ marginRight: 2 }}>{selectedCustomerToManagerMap.reducedName ? selectedCustomerToManagerMap.reducedName : getCurrentUser.customer.reducedName}</Typography>

                        <CardMedia
                            style={{
                                height: 35,
                                width: 35,
                                borderRadius: 100,
                                margin: 0,
                                objectFit: "contain"
                            }}
                            component="img"
                            alt="Imagem"
                            src={selectedCustomerToManagerMap.image ? selectedCustomerToManagerMap.image : (!getCurrentUser.configs.isManager && getCurrentUser.customer.image ? getCurrentUser.customer.image : require("../../../assets/files/tracker.png"))}
                        />
                    </Box>
                </>
            </DrawerBottomList>
        </Box>
    );
};

const style: React.CSSProperties = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#f3f4f6",
    border: "none",
    boxShadow: "none",
    borderRadius: 1,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 2,
    fontFamily: "Prometo",
    zIndex: 999999,
    maxWidth: "890px"
};

export default DashMap;
